(function () {
  if (window.cbQuizBuilderV5Loaded) {
    return;
  }

  window.cbQuizBuilderV5Loaded = true;

  window.CHARM_PRODUCT_TAGS =
  window.CHARM_PRODUCT_TAGS || {};

  var overlay =
    document.getElementById('cb-quiz-overlay');

  var designStart =
  document.getElementById(
    'cb-design-start'
  );

var quizFlow =
  document.getElementById(
    'cb-quiz-flow'
  );

var promptModeBtn =
  document.getElementById(
    'cb-mode-prompt'
  );

var quizModeBtn =
  document.getElementById(
    'cb-mode-quiz'
  );

var scratchModeBtn =
  document.getElementById(
    'cb-mode-scratch'
  );

  var promptFlow =
  document.getElementById(
    'cb-prompt-flow'
  );

var promptInput =
  document.getElementById(
    'cb-prompt-input'
  );

if (promptInput) {

  promptInput.maxLength =
    600;


  var promptCounter =
    document.createElement(
      'div'
    );

  promptCounter.className =
    'cb-prompt-counter';


  promptInput.insertAdjacentElement(
    'afterend',
    promptCounter
  );


  function updatePromptCounter() {

    promptCounter.textContent =
      promptInput.value.length +
      ' / 600';

  }


  promptInput.addEventListener(
    'input',
    updatePromptCounter
  );


  updatePromptCounter();

}

var promptGenerateBtn =
  document.getElementById(
    'cb-prompt-generate'
  );

  var promptGenerateAiBtn = null;


if (promptGenerateBtn) {

  /*
    Existing button stays LOCAL.
    Clone it so both buttons automatically
    keep exactly the same existing classes/styles.
  */

  promptGenerateBtn.textContent =
    'Generate without AI';


  promptGenerateAiBtn =
    promptGenerateBtn.cloneNode(true);

  promptGenerateAiBtn.id =
    'cb-prompt-generate-ai';

  promptGenerateAiBtn.textContent =
    '✨ Generate';


  promptGenerateBtn.insertAdjacentElement(
    'afterend',
    promptGenerateAiBtn
  );

}

var promptBackBtn =
  document.getElementById(
    'cb-prompt-back'
  );

var promptUnderstood =
  document.getElementById(
    'cb-prompt-understood'
  );

  var openBtn =
    document.getElementById('cb-quiz-trigger');

  var closeBtn =
    document.getElementById('cb-quiz-close');

  var titleEl =
    document.getElementById('cb-question-title');

  var subtitleEl =
    document.getElementById('cb-question-subtitle');

  var optionsEl =
    document.getElementById('cb-question-options');

  var nextBtn =
    document.getElementById('cb-next');

  var prevBtn =
    document.getElementById('cb-prev');

  var progressFill =
    document.querySelector('.cb-quiz-progress-fill');

  var progressText =
    document.querySelector('.cb-quiz-progress-text');

  var resultView =
    document.getElementById('cb-result-view');

  /* ==========================================================
   CUSTOMER ERROR UI
========================================================== */

function showPromptAiError(message) {

  if (!promptFlow) {
    return;
  }

  var errorEl =
    promptFlow.querySelector(
      '.cb-prompt-ai-error'
    );


  if (!errorEl) {

    errorEl =
      document.createElement('div');

    errorEl.className =
      'cb-inline-error cb-prompt-ai-error';

    errorEl.setAttribute(
      'role',
      'alert'
    );

    errorEl.setAttribute(
      'aria-live',
      'polite'
    );


    if (promptGenerateAiBtn) {

      promptGenerateAiBtn
        .insertAdjacentElement(
          'afterend',
          errorEl
        );

    } else {

      promptFlow.appendChild(
        errorEl
      );

    }

  }


  errorEl.textContent =
    String(message || '');

  errorEl.hidden = false;
}


function clearPromptAiError() {

  if (!promptFlow) {
    return;
  }

  var errorEl =
    promptFlow.querySelector(
      '.cb-prompt-ai-error'
    );

  if (!errorEl) {
    return;
  }

  errorEl.textContent = '';
  errorEl.hidden = true;
}


function showResultApplyError(message) {

  if (!resultView) {
    return;
  }

  var errorEl =
    resultView.querySelector(
      '.cb-result-apply-error'
    );


  if (!errorEl) {

    errorEl =
      document.createElement('div');

    errorEl.className =
      'cb-inline-error cb-result-apply-error';

    errorEl.setAttribute(
      'role',
      'alert'
    );

    errorEl.setAttribute(
      'aria-live',
      'polite'
    );

    resultView.prepend(
      errorEl
    );

  }


  errorEl.textContent =
    String(message || '');

  errorEl.hidden = false;
}


function clearResultApplyError() {

  if (!resultView) {
    return;
  }

  var errorEl =
    resultView.querySelector(
      '.cb-result-apply-error'
    );

  if (!errorEl) {
    return;
  }

  errorEl.textContent = '';
  errorEl.hidden = true;
}

  var state = {
  step: 0,
  answers: {},
  designs: [],
  activeDesignIndex: 0,
  isApplyingDesign: false,
  resultWasGenerated: false,
  resultSource: null
};

var quizImagesPreloaded = false;
var quizImagePreloadSet = new Set();

  var ZODIACS = [
  {
    key: 'aries',
    label: 'Aries',
    dates: '21 Mar – 19 Apr',
    tag: 'motiv:znameni-beran',
    keywords: ['aries', 'beran']
  },
  {
    key: 'taurus',
    label: 'Taurus',
    dates: '20 Apr – 20 May',
    tag: 'motiv:znameni-byk',
    keywords: ['taurus', 'býk', 'byk']
  },
  {
    key: 'gemini',
    label: 'Gemini',
    dates: '21 May – 20 Jun',
    tag: 'motiv:znameni-blizenci',
    keywords: ['gemini', 'blíženci', 'blizenci']
  },
  {
    key: 'cancer',
    label: 'Cancer',
    dates: '21 Jun – 22 Jul',
    tag: 'motiv:znameni-rak',
    keywords: ['cancer', 'rak']
  },
  {
    key: 'leo',
    label: 'Leo',
    dates: '23 Jul – 22 Aug',
    tag: 'motiv:znameni-lev',
    keywords: ['leo', 'lev']
  },
  {
    key: 'virgo',
    label: 'Virgo',
    dates: '23 Aug – 22 Sep',
    tag: 'motiv:znameni-panna',
    keywords: ['virgo', 'panna']
  },
  {
    key: 'libra',
    label: 'Libra',
    dates: '23 Sep – 22 Oct',
    tag: 'motiv:znameni-vahy',
    keywords: ['libra', 'váhy', 'vahy']
  },
  {
    key: 'scorpio',
    label: 'Scorpio',
    dates: '23 Oct – 21 Nov',
    tag: 'motiv:znameni-stir',
    keywords: ['scorpio', 'štír', 'stir']
  },
  {
    key: 'sagittarius',
    label: 'Sagittarius',
    dates: '22 Nov – 21 Dec',
    tag: 'motiv:znameni-strelec',
    keywords: ['sagittarius', 'střelec', 'strelec']
  },
  {
    key: 'capricorn',
    label: 'Capricorn',
    dates: '22 Dec – 19 Jan',
    tag: 'motiv:znameni-kozoroh',
    keywords: ['capricorn', 'kozoroh']
  },
  {
    key: 'aquarius',
    label: 'Aquarius',
    dates: '20 Jan – 18 Feb',
    tag: 'motiv:znameni-vodnar',
    keywords: ['aquarius', 'vodnář', 'vodnar']
  },
  {
    key: 'pisces',
    label: 'Pisces',
    dates: '19 Feb – 20 Mar',
    tag: 'motiv:znameni-ryby',
    keywords: ['pisces', 'ryby']
  }
];


/* ==========================================================
   QUIZ → CANONICAL TAXONOMY
========================================================== */

var INTEREST_MAP = {

  love: {
    label: 'Love',
    emoji: '💖',
    tags: [
      'tema:laska'
    ]
  },

  travel: {
    label: 'Travel',
    emoji: '✈️',
    tags: [
      'motiv:cestovani'
    ]
  },

  nature: {
    label: 'Nature',
    emoji: '🌿',
    tags: [
      'motiv:priroda'
    ]
  },

  animals: {
    label: 'Animals',
    emoji: '🐾',
    tags: [
      'motiv:zvirata'
    ]
  },

  music: {
    label: 'Music',
    emoji: '🎵',
    tags: [
      'motiv:hudba'
    ]
  },

  ocean: {
    label: 'Ocean',
    emoji: '🌊',
    tags: [
      'motiv:vodni-zvirata',
      'motiv:vlna',
      'motiv:musle',
      'motiv:morska-hvezdice',
      'motiv:morsky-konik',
      'motiv:kotva'
    ]
  },

  flowers: {
    label: 'Flowers',
    emoji: '🌸',
    tags: [
      'motiv:kvetiny-a-rostliny'
    ]
  },

  coffee: {
    label: 'Coffee',
    emoji: '☕',
    tags: [
      'motiv:kava-a-caj',
      'motiv:salek-kavy'
    ]
  },

  luck: {
    label: 'Luck',
    emoji: '🍀',
    tags: [
      'tema:stesti',
      'motiv:symboly-stesti'
    ]
  },

  stars: {
    label: 'Stars',
    emoji: '✨',
    tags: [
      'motiv:nebeska-telesa',
      'motiv:hvezda',
      'motiv:mesic',
      'motiv:vesmir',
      'motiv:slunce-a-mesic'
    ]
  }

};


/* ==========================================================
   RECIPIENT
========================================================== */

/* ==========================================================
   RECIPIENT
========================================================== */

var RECIPIENT_TAG_MAP = {

  /*
    Romantic relationship.

    Love is the strongest match.
    Connection is the fallback.
  */

  partner: {

    tags: [
      'tema:laska'
    ],

    fallbackTags: [
      'tema:spojeni'
    ]

  },


  /*
    Friendship first.

    If unavailable:
    connection → general love/bond.
  */

  friend: {

    tags: [
      'tema:pratelstvi'
    ],

    fallbackTags: [
      'tema:spojeni',
      'tema:laska'
    ]

  },


  /*
    Keep Family as the semantic exact request.

    There are currently no tema:rodina
    products, so it naturally falls back to:

    family → love → connection

    If tema:rodina products are added later,
    they automatically become the first choice.
  */

  family: {

    tags: [
      'tema:rodina'
    ],

    fallbackTags: [
      'tema:laska',
      'tema:spojeni'
    ]

  },


  /*
    No separate recipient charm.

    Personalization is already handled through
    initials / birthstone / explicit concepts.

    This also prevents random initial charms
    from being selected through
    individualita / sebevyjadreni.
  */

  myself: {

    tags: [],

    fallbackTags: []

  },


  /*
    A generic gift does not imply
    a specific semantic charm.
  */

  gift: {

    tags: [],

    fallbackTags: []

  }

};


/* ==========================================================
   SELECTED DESIGN STYLE
========================================================== */

var DESIGN_WEIGHT_TAG_MAP = {

  delicate: [
    'styl:jemny',
    'styl:minimalisticky',
    'styl:elegantni'
  ],

  bold: [
    'styl:vyrazny'
  ],

  playful: [
    'styl:hravy',
    'styl:roztomily'
  ]

};


/* ==========================================================
   THREE RESULT VARIANTS
========================================================== */

var DESIGN_TYPE_TAG_MAP = {

  safe: [
    'styl:minimalisticky',
    'styl:klasicky',
    'styl:elegantni',
    'styl:jemny'
  ],

  personal: [
    'styl:symbolicky',
    'tema:individualita',
    'tema:sebevyjadreni'
  ],

  statement: [
    'styl:vyrazny',
    'styl:barevny',
    'styl:moderni',
    'styl:rebelsky'
  ]

};


/* ==========================================================
   BROAD BUCKETS
   Used only for diversity between recommended charms.
========================================================== */

var QUIZ_BUCKET_TAGS = [

  'motiv:zvirata',
  'motiv:gastro',
  'motiv:priroda',
  'motiv:cestovani',
  'motiv:moda',
  'motiv:hry',
  'motiv:sport',
  'motiv:hobby',
  'motiv:veda-a-povolani',
  'motiv:astrologie-a-symboly',
  'motiv:fantazie',
  'motiv:pismena-a-vzkazy',
  'motiv:predmety-a-technika',
  'motiv:hudba'

];


/* Optional, useful for checking mappings in DevTools */
window.CBQuizTagMap = {
  interests: INTEREST_MAP,
  recipients: RECIPIENT_TAG_MAP,
  designWeights: DESIGN_WEIGHT_TAG_MAP,
  designTypes: DESIGN_TYPE_TAG_MAP,
  zodiacs: ZODIACS
};

  var QUESTIONS = [
    {
      id: 'metal',
      title: 'Choose your color',
      subtitle: 'We will match all bases, initials and zodiac charms to this color.',
      type: 'single',
      layout: 'grid-2',
      options: function () {
        return [
          {
            value: 'gold',
            label: 'Gold',
            image: getBestBaseImage(['zlatý', 'zlatá', 'zlaty', 'zlata', 'gold'])
          },
          {
            value: 'silver',
            label: 'Silver',
            image: getBestBaseImage(['stříbrný', 'stříbrná', 'stribrny', 'stribrna', 'silver', 'silv'])
          }
        ];
      }
    },
    {
      id: 'jewelryType',
      title: 'What would you like to create?',
      subtitle: 'Choose the base direction first. You can still adjust the final design later.',
      type: 'single',
      layout: 'grid-2',
      options: function () {
        var metal =
          state.answers.metal || 'gold';

        return [
          {
            value: 'necklace',
            label: 'Necklace',
            image: getBaseOptionImage({
              metal: metal,
              jewelryType: 'necklace',
              designWeight: 'bold'
            })
          },
          {
            value: 'bracelet',
            label: 'Bracelet',
            image: getBaseOptionImage({
              metal: metal,
              jewelryType: 'bracelet',
              designWeight: 'delicate'
            })
          }
        ];
      }
    },
    {
      id: 'designWeight',
      title: 'Choose your design style',
      subtitle: 'This decides which base fits your look best.',
      type: 'single',
      layout: 'auto',
      options: function () {
        var jewelryType =
          state.answers.jewelryType;

        var metal =
          state.answers.metal || 'gold';

        if (jewelryType === 'bracelet') {
          return [
            {
              value: 'bold',
              label: 'Bold',
              image: getBaseOptionImage({
                metal: metal,
                jewelryType: 'bracelet',
                designWeight: 'bold'
              })
            },
            {
              value: 'delicate',
              label: 'Delicate',
              image: getBaseOptionImage({
                metal: metal,
                jewelryType: 'bracelet',
                designWeight: 'delicate'
              })
            },
            {
              value: 'playful',
              label: 'Playful',
              image: getBaseOptionImage({
                metal: metal,
                jewelryType: 'bracelet',
                designWeight: 'playful'
              })
            }
          ];
        }

        return [
          {
            value: 'bold',
            label: 'Bold',
            image: getBaseOptionImage({
              metal: metal,
              jewelryType: 'necklace',
              designWeight: 'bold'
            })
          },
          {
            value: 'delicate',
            label: 'Delicate',
            image: getBaseOptionImage({
              metal: metal,
              jewelryType: 'necklace',
              designWeight: 'delicate'
            })
          }
        ];
      }
    },
    {
      id: 'recipient',
      title: 'Who are you creating this for?',
      subtitle: 'This helps us choose between personal, romantic and universal motifs.',
      type: 'single',
      layout: 'grid-3',
      options: function () {
        return [
          {
            value: 'myself',
            label: 'Myself',
            emoji: '💖',
          },
          {
            value: 'partner',
            label: 'My partner',
            emoji: '❤️',
          },
          {
            value: 'friend',
            label: 'A friend',
            emoji: '👯',
          },
          {
            value: 'family',
            label: 'Family',
            emoji: '🌷',
          },
          {
            value: 'gift',
            label: 'A gift',
            emoji: '🎁',
          }
        ];
      }
    },
    {
      id: 'interests',
      title: 'What are you into?',
      subtitle: 'Choose up to 3. We will use these to score and rank matching charms.',
      type: 'multi',
      max: 3,
      layout: 'grid-4',
      options: function () {
        return Object.keys(INTEREST_MAP).map(function (key) {
          return {
            value: key,
            label: INTEREST_MAP[key].label,
            emoji: INTEREST_MAP[key].emoji
          };
        });
      }
    },
    {
      id: 'initial1',
      title: 'Add a first initial',
      type: 'letters',
      optional: false
    },
    {
      id: 'initial2',
      title: 'Add a second initial',
      subtitle: 'Optional. Skip this if you want to keep the design cleaner.',
      type: 'letters',
      optional: true
    },
    {
      id: 'zodiac',
      title: 'Pick a birthstone',
      type: 'zodiac',
      optional: true
    }
  ];

  function init() {

    if (promptInput) {

  promptInput.addEventListener(
  'input',
  function () {

    clearPromptAiError();

    var text =
      promptInput.value.trim();

      var parsed =
        parseNaturalLanguagePrompt(
          text
        );

      renderPromptUnderstanding(
        parsed
      );


      if (promptGenerateBtn) {

  promptGenerateBtn.disabled =
    text.length < 3;

}


if (promptGenerateAiBtn) {

  promptGenerateAiBtn.disabled =
    text.length < 3;

}

    }
  );

}

Array.from(
  document.querySelectorAll(
    '.cb-prompt-example'
  )
).forEach(function (button) {

  button.addEventListener(
    'click',
    function () {

      if (!promptInput) {
        return;
      }

      promptInput.value =
        button.dataset.prompt || '';

      promptInput.dispatchEvent(
        new Event(
          'input',
          {
            bubbles: true
          }
        )
      );

      promptInput.focus();

    }
  );

});

if (promptBackBtn) {

  promptBackBtn.addEventListener(
    'click',
    function () {

      showDesignStart();

    }
  );

}

if (promptGenerateBtn) {

  promptGenerateBtn.addEventListener(
    'click',
    function () {

      if (!promptInput) {
        return;
      }


      var parsed =
        parseNaturalLanguagePrompt(
          promptInput.value
        );


      /*
        Defaults für Dinge, die der User
        nicht erwähnt hat.
      */

      if (!parsed.metal) {
        parsed.metal = 'gold';
      }

      if (!parsed.jewelryType) {
        parsed.jewelryType =
          'bracelet';
      }

      /*
  Remember whether the user actually
  specified a style.

  "delicate" may still be used internally
  as a fallback, but it must not be treated
  as an explicit customer choice.
*/

parsed.designWeightExplicit =
  !!parsed.designWeight;


if (!parsed.designWeight) {

  parsed.designWeight =
    'delicate';

}

      if (
        !Array.isArray(
          parsed.interests
        )
      ) {
        parsed.interests = [];
      }


      state.answers =
        parsed;


      /*
        Result UI lives inside quizFlow.
      */

      state.resultSource = 'prompt';

      if (promptFlow) {
        promptFlow.hidden = true;
      }

      if (quizFlow) {
        quizFlow.hidden = false;
      }


      generateAndShowResults();

    }
  );

}

if (promptGenerateAiBtn) {

  promptGenerateAiBtn.addEventListener(
    'click',
    async function () {

      if (!promptInput) {
        return;
      }


      var text =
        promptInput.value.trim();


      if (text.length < 3) {
  return;
}


clearPromptAiError();


promptGenerateAiBtn.disabled =
  true;

      var originalText =
        promptGenerateAiBtn.textContent;

      promptGenerateAiBtn.textContent =
        'Understanding...';


      try {

        var aiResult =
          await parsePromptWithAI(
            text
          );


        console.log(
          '[Charm Bar AI result]',
          aiResult
        );

        var aiAnswers =
  buildBuilderAnswersFromAI(
    aiResult
  );


console.log(
  '[Charm Bar AI → Builder answers]',
  aiAnswers
);


console.table(
  aiAnswers.taxonomyMatches.map(
    function (match) {

      return {
        original:
          match.aiOriginal,

        canonical:
          match.aiCanonical,

        resolvedFrom:
          match.aiResolvedFrom,

        resolution:
          match.aiResolutionLevel,

        taxonomy:
          match.key,

        fallback1:
          match.fallbackKey1,

        fallback2:
          match.fallbackKey2
      };

    }
  )
);


/*
  Show the mapped AI understanding
  in the existing debug UI.
*/

renderPromptUnderstanding(
  aiAnswers
);

/*
  Hand mapped AI answers to the
  existing recommendation engine.
*/

state.answers =
  aiAnswers;

state.resultSource =
  'prompt-ai';


/*
  Result UI lives inside quizFlow.
*/

if (promptFlow) {
  promptFlow.hidden = true;
}

if (quizFlow) {
  quizFlow.hidden = false;
}


/*
  From here on we use the exact same
  generator as the normal quiz/local prompt.
*/

generateAndShowResults();


        /*
          IMPORTANT:
          We deliberately do NOT generate
          a design yet.

          Phase 11.2 will convert aiResult
          into state.answers + taxonomy matches.
        */


      }
      catch (error) {

  console.error(
    '[Charm Bar AI]',
    error
  );


  if (
    error &&
    error.code ===
      'AI_TIMEOUT'
  ) {

    showPromptAiError(
      'This is taking longer than expected. Please try again.'
    );

  } else {

    showPromptAiError(
      'Something went wrong. Please try again or generate without AI.'
    );

  }

}
      finally {

  promptGenerateAiBtn.disabled =
    !promptInput ||
    promptInput.value.trim().length < 3;

  promptGenerateAiBtn.textContent =
    originalText;

}

    }
  );

}

    if (
      !overlay ||
      !openBtn ||
      !closeBtn ||
      !titleEl ||
      !subtitleEl ||
      !optionsEl ||
      !nextBtn ||
      !prevBtn ||
      !progressFill ||
      !progressText ||
      !resultView
    ) {
      console.warn('[Charm Bar Quiz] Required quiz elements missing.');
      return;
    }

    openBtn.addEventListener('click', openQuiz);
    closeBtn.addEventListener('click', closeQuiz);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeQuiz();
      }
    });

    nextBtn.addEventListener('click', handleNext);
    prevBtn.addEventListener('click', handlePrev);

    if (quizModeBtn) {

  quizModeBtn.addEventListener(
    'click',
    function () {

      showQuizMode();

    }
  );

}


if (scratchModeBtn) {

  scratchModeBtn.addEventListener(
    'click',
    function () {

      closeQuiz();

    }
  );

}


if (promptModeBtn) {

  promptModeBtn.addEventListener(
    'click',
    function () {

      showPromptMode();

    }
  );

}

    renderQuestion();

    window.setTimeout(function () {
  openQuiz();
}, 150);
  }

/* ==========================================================
   NATURAL LANGUAGE → TAXONOMY
========================================================== */

function normalizeTaxonomyPhrase(value) {

  return normalizeText(
    String(value || '')
  )
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

}


function containsWholePhrase(
  normalizedText,
  normalizedPhrase
) {

  if (
    !normalizedText ||
    !normalizedPhrase
  ) {
    return false;
  }


  return (
    ' ' +
    normalizedText +
    ' '
  ).indexOf(
    ' ' +
    normalizedPhrase +
    ' '
  ) !== -1;

}


function findNaturalLanguageTaxonomyMatches(
  input
) {

  var taxonomy =
    window.CHARM_TAXONOMY_TERMS || [];


  if (!taxonomy.length) {

    console.warn(
      '[Charm Bar] CHARM_TAXONOMY_TERMS is empty.'
    );

    return [];
  }


  var text =
    normalizeTaxonomyPhrase(
      input
    );


  /*
    Natural-language charm concepts.

    Themes are currently excluded here because
    recipient logic already handles things like
    partner → love.

    Color/style are also handled separately.
  */
  var allowedGroups = [
    'main_motif',
    'motif_family',
    'overall_motif'
  ];


  var groupPriority = {
    main_motif: 3,
    motif_family: 2,
    overall_motif: 1
  };


  var matches = [];


  taxonomy.forEach(function (term) {

    if (
      !term ||
      !term.key ||
      allowedGroups.indexOf(
        term.group
      ) === -1
    ) {
      return;
    }


    /*
      Initials and zodiac are handled by their
      own dedicated parser logic.
    */
    if (
      term.key.indexOf(
        'motiv:pismeno-'
      ) === 0 ||
      term.key.indexOf(
        'motiv:znameni-'
      ) === 0
    ) {
      return;
    }


    var phrases =
      [term.name]
        .concat(
          Array.isArray(
            term.synonyms
          )
            ? term.synonyms
            : []
        )
        .map(
          normalizeTaxonomyPhrase
        )
        .filter(function (phrase) {

          /*
            Avoid tiny dangerous matches.
            Example: single letters.
          */
          return phrase.length >= 3;

        });


    phrases =
      Array.from(
        new Set(
          phrases
        )
      );


    /*
      Prefer longer/more specific phrases:
      "pizza slice" before "pizza".
    */
    phrases.sort(function (a, b) {
      return b.length - a.length;
    });


    var matchedPhrase =
      phrases.find(function (phrase) {

        return containsWholePhrase(
          text,
          phrase
        );

      });


    if (!matchedPhrase) {
      return;
    }


    matches.push({

      key:
        term.key,

      name:
        term.name,

      group:
        term.group,

      matchedPhrase:
        matchedPhrase,

      familyKey:
        term.family_key || '',

      overallKey:
        term.overall_key || '',

      fallbackKey1:
        term.fallback_key_1 || '',

      fallbackKey2:
        term.fallback_key_2 || '',

      priority:
        groupPriority[
          term.group
        ] || 0

    });

  });


  /*
    More specific taxonomy terms first.
  */
  matches.sort(function (a, b) {

    if (
      b.priority !==
      a.priority
    ) {
      return (
        b.priority -
        a.priority
      );
    }


    return (
      b.matchedPhrase.length -
      a.matchedPhrase.length
    );

  });


  /*
    If one phrase matched multiple hierarchy
    levels, keep the most specific one.

    Example:
    "dog" should become Pes, not both
    Pes + Animals.
  */
  var usedPhrases =
    new Set();

  var usedKeys =
    new Set();


  matches =
    matches.filter(function (match) {

      if (
        usedKeys.has(
          match.key
        )
      ) {
        return false;
      }


      if (
        usedPhrases.has(
          match.matchedPhrase
        )
      ) {
        return false;
      }


      usedKeys.add(
        match.key
      );

      usedPhrases.add(
        match.matchedPhrase
      );


      return true;

    });


  return matches;

}

async function parsePromptWithAI(
  input
) {

  var endpoint =
    window.CHARM_AI_ENDPOINT;


  if (!endpoint) {

    throw new Error(
      'CHARM_AI_ENDPOINT is not configured'
    );

  }


  var text =
    String(input || '')
      .trim();


  if (text.length < 3) {

    throw new Error(
      'Prompt is too short'
    );

  }

if (text.length > 600) {

  throw new Error(
    'Prompt is too long'
  );

}

  /*
    Frontend safety timeout.

    The Worker already has its own timeout,
    but this prevents the customer's browser
    from waiting indefinitely if the network
    itself gets stuck.
  */

  var controller =
    new AbortController();

  var timeoutId =
    window.setTimeout(
      function () {

        controller.abort();

      },
      12000
    );


  var response;


  try {

    response =
      await fetch(
        endpoint,
        {
          method:
            'POST',

          headers: {
            'Content-Type':
              'application/json'
          },

          credentials:
            'omit',

          signal:
            controller.signal,

          body:
            JSON.stringify({
              text: text
            })
        }
      );

  }
  catch (error) {

    if (
      error &&
      error.name ===
        'AbortError'
    ) {

      var timeoutError =
        new Error(
          'AI request timed out'
        );

      timeoutError.code =
        'AI_TIMEOUT';

      throw timeoutError;
    }


    var networkError =
      new Error(
        'AI network request failed'
      );

    networkError.code =
      'AI_NETWORK';

    throw networkError;

  }
  finally {

    window.clearTimeout(
      timeoutId
    );

  }


  var data = null;


  try {

    data =
      await response.json();

  }
  catch (error) {

    var jsonError =
      new Error(
        'AI returned invalid JSON'
      );

    jsonError.code =
      'AI_RESPONSE';

    throw jsonError;

  }


  if (
    !response.ok ||
    !data ||
    data.ok !== true ||
    !data.result
  ) {

    var responseError =
      new Error(
        data &&
        data.error
          ? data.error
          : 'AI request failed'
      );

    responseError.code =
      'AI_RESPONSE';

    throw responseError;

  }


  return data.result;
}

/* ==========================================================
   AI RESULT → BUILDER TAXONOMY
========================================================== */

/* ==========================================================
   AI QUERY → TAXONOMY TERM

   Unlike the normal local prompt matcher,
   AI concepts may also resolve to themes.

   Example:
   "love" → tema:laska
========================================================== */

function findAIQueryTaxonomyMatch(
  query,
  mode
) {

  var taxonomy =
    window.CHARM_TAXONOMY_TERMS || [];


  if (!taxonomy.length) {
    return null;
  }


  var text =
    normalizeTaxonomyPhrase(
      query
    );


  if (!text) {
    return null;
  }


  var isBroader =
    mode === 'broader';


  /*
    Canonical:
    Prefer a concrete motif.

    Broader:
    Do NOT resolve back into another
    concrete main motif.

    Examples:

    dog
    → pets       = motif_family
    → animals    = overall_motif

    heart
    → love       = theme
  */

  var allowedGroups =
    isBroader
      ? [
          'motif_family',
          'overall_motif',
          'theme'
        ]
      : [
          'main_motif',
          'motif_family',
          'overall_motif',
          'theme'
        ];


  var groupPriority =
    isBroader
      ? {
          theme: 3,
          motif_family: 2,
          overall_motif: 1
        }
      : {
          main_motif: 4,
          motif_family: 3,
          overall_motif: 2,
          theme: 1
        };


  var matches = [];


  taxonomy.forEach(function (term) {

    if (
      !term ||
      !term.key ||
      allowedGroups.indexOf(
        term.group
      ) === -1
    ) {
      return;
    }


    var phrases =
      [term.name]
        .concat(
          Array.isArray(term.synonyms)
            ? term.synonyms
            : []
        )
        .map(
          normalizeTaxonomyPhrase
        )
        .filter(Boolean);


    var matchedPhrase =
      phrases.find(function (phrase) {

        return containsWholePhrase(
          text,
          phrase
        );

      });


    if (!matchedPhrase) {
      return;
    }


    matches.push({

      key:
        term.key,

      name:
        term.name,

      group:
        term.group,

      matchedPhrase:
        matchedPhrase,

      familyKey:
        term.family_key || '',

      overallKey:
        term.overall_key || '',

      fallbackKey1:
        term.fallback_key_1 || '',

      fallbackKey2:
        term.fallback_key_2 || '',

      priority:
        groupPriority[
          term.group
        ] || 0

    });

  });


  matches.sort(function (a, b) {

    if (
      b.priority !==
      a.priority
    ) {

      return (
        b.priority -
        a.priority
      );

    }


    return (
      b.matchedPhrase.length -
      a.matchedPhrase.length
    );

  });


  return matches[0] || null;

}

function resolveOneAIConceptToTaxonomy(
  concept
) {

  if (
    !concept ||
    typeof concept !== 'object'
  ) {
    return null;
  }


  /*
    One semantic concept with ordered fallbacks.

    Example:

    dog
    → pets
    → animals

    heart
    → love
  */

  var queries = [
    concept.canonical
  ]
    .concat(
      Array.isArray(concept.broader)
        ? concept.broader
        : []
    )
    .map(function (value) {
      return String(value || '').trim();
    })
    .filter(Boolean);


  queries =
    Array.from(
      new Set(queries)
    );


  /*
    Resolve every semantic level separately.
  */

  var resolvedLevels =
    queries
      .map(function (query, index) {

        var match =
  findAIQueryTaxonomyMatch(
    query,
    index === 0
      ? 'canonical'
      : 'broader'
  );


        if (!match) {
          return null;
        }


        return {
          query:
            query,

          index:
            index,

          match:
            match
        };

      })
      .filter(Boolean);


  /*
    Nothing in the taxonomy matched.
  */

  if (!resolvedLevels.length) {
    return null;
  }


  /*
    First successful semantic level becomes
    the primary requested taxonomy term.

    Normally this is canonical.
  */

  var primary =
    resolvedLevels[0];

  var primaryMatch =
    primary.match;


  /*
    AI-provided broader concepts have priority
    as fallbacks.

    Only afterwards do we use the normal
    taxonomy hierarchy as additional fallback.
  */

  var fallbackKeys =
    resolvedLevels
      .slice(1)
      .map(function (level) {

        return level.match.key;

      });


  fallbackKeys.push(
    primaryMatch.fallbackKey1,
    primaryMatch.fallbackKey2
  );


  fallbackKeys =
    fallbackKeys
      .filter(Boolean)
      .filter(function (
        key,
        index,
        array
      ) {

        return (
          key !== primaryMatch.key &&
          array.indexOf(key) === index
        );

      })
      .slice(0, 2);


  return {

    key:
      primaryMatch.key,

    name:
      primaryMatch.name,

    group:
      primaryMatch.group,

    matchedPhrase:
      primaryMatch.matchedPhrase,

    familyKey:
      primaryMatch.familyKey || '',

    overallKey:
      primaryMatch.overallKey || '',

    fallbackKey1:
      fallbackKeys[0] || '',

    fallbackKey2:
      fallbackKeys[1] || '',


    /*
      AI debug information.
    */

    aiOriginal:
      concept.original || '',

    aiCanonical:
      concept.canonical || '',

    aiResolvedFrom:
      primary.query,

    aiResolutionLevel:
      primary.index === 0
        ? 'canonical'
        : 'broader-' +
          primary.index

  };

}



function resolveAIConceptsToTaxonomy(
  concepts
) {

  var matches = [];
  var unmatched = [];

  var usedKeys =
    new Set();


  (
    Array.isArray(concepts)
      ? concepts
      : []
  ).forEach(function (concept) {

    var match =
      resolveOneAIConceptToTaxonomy(
        concept
      );


    if (!match) {

      unmatched.push({
        original:
          concept &&
          concept.original
            ? concept.original
            : '',

        canonical:
          concept &&
          concept.canonical
            ? concept.canonical
            : ''
      });

      return;
    }


    /*
      Do not create the same semantic taxonomy
      slot twice.
    */

    if (
      usedKeys.has(
        match.key
      )
    ) {
      return;
    }


    usedKeys.add(
      match.key
    );


    matches.push(
      match
    );

  });


  return {
    matches:
      matches,

    unmatched:
      unmatched
  };

}



/* ==========================================================
   AI RESULT → state.answers
========================================================== */

function buildBuilderAnswersFromAI(
  ai
) {

  ai =
    ai &&
    typeof ai === 'object'
      ? ai
      : {};


  var resolved =
    resolveAIConceptsToTaxonomy(
      ai.concepts
    );


  var answers = {

    /*
      Same defaults as the existing
      non-AI prompt flow.
    */

    metal:
      ai.metal &&
      ai.metal !== 'unknown'
        ? ai.metal
        : 'gold',

    jewelryType:
      ai.jewelryType &&
      ai.jewelryType !== 'unknown'
        ? ai.jewelryType
        : 'bracelet',

    designWeight:
      ai.designWeight &&
      ai.designWeight !== 'unknown'
        ? ai.designWeight
        : 'delicate',

        designWeightExplicit:
  !!(
    ai.designWeight &&
    ai.designWeight !== 'unknown'
  ),


    interests: [],

    taxonomyMatches:
      resolved.matches,

    unmatchedConcepts:
      resolved.unmatched,


    /*
      Useful AI metadata.
    */

    personName:
      ai.personName || '',

    recipientDetail:
      ai.recipientDetail || '',

    aiLanguage:
      ai.language || 'other',

    birthDay:
      Number.isInteger(ai.birthDay)
        ? ai.birthDay
        : 0,

    birthMonth:
      ai.birthMonth || 'unknown',

    birthDatePrecision:
      ai.birthDatePrecision ||
      'unknown'

  };


  /*
    Recipient
  */

  if (
    ai.recipient &&
    ai.recipient !== 'unknown'
  ) {

    answers.recipient =
      ai.recipient;

  }


  /*
    Initials
  */

  if (
    Array.isArray(ai.initials)
  ) {

    if (ai.initials[0]) {

      answers.initial1 =
        String(
          ai.initials[0]
        )
          .trim()
          .toUpperCase()
          .charAt(0);

    }


    if (ai.initials[1]) {

      answers.initial2 =
        String(
          ai.initials[1]
        )
          .trim()
          .toUpperCase()
          .charAt(0);

    }

  }


  /*
    Zodiac / birthstone
  */

  if (
    ai.zodiac &&
    ai.zodiac !== 'unknown'
  ) {

    answers.zodiac =
      ai.zodiac;

  }


  return answers;

}

/* ==========================================================
   TEMP DEBUG EXPORTS
========================================================== */

window.CB_AI_DEBUG = {
  buildBuilderAnswersFromAI:
    buildBuilderAnswersFromAI,

  resolveOneAIConceptToTaxonomy:
    resolveOneAIConceptToTaxonomy,

  resolveAIConceptsToTaxonomy:
    resolveAIConceptsToTaxonomy,

  findAIQueryTaxonomyMatch:
    findAIQueryTaxonomyMatch
};

function parseNaturalLanguagePrompt(input) {

  var text =
    normalizeText(
      String(input || '')
    );

  var answers = {
  interests: [],
  taxonomyMatches: []
};


  /* ======================================================
     METAL
  ====================================================== */

  if (
    /\b(gold|golden|zlat|zlaty|zlata)\b/.test(text)
  ) {
    answers.metal = 'gold';
  }

  if (
    /\b(silver|stribr|stribrny|stribrna)\b/.test(text)
  ) {
    answers.metal = 'silver';
  }


  /* ======================================================
     JEWELRY TYPE
  ====================================================== */

  if (
    /\b(necklace|necklaces|nahrdelnik|chain)\b/.test(text)
  ) {
    answers.jewelryType =
      'necklace';
  }

  if (
    /\b(bracelet|bracelets|naramek)\b/.test(text)
  ) {
    answers.jewelryType =
      'bracelet';
  }


  /* ======================================================
     DESIGN WEIGHT
  ====================================================== */

  if (
    /\b(delicate|minimal|minimalist|minimalistic|elegant|subtle|dainty|jemny|jemna)\b/.test(text)
  ) {
    answers.designWeight =
      'delicate';
  }

  if (
    /\b(bold|statement|chunky|strong|vyrazny|vyrazna)\b/.test(text)
  ) {
    answers.designWeight =
      'bold';
  }

  if (
    /\b(playful|cute|fun|colorful|colourful|hravy|hrava|roztomily|roztomila)\b/.test(text)
  ) {
    answers.designWeight =
      'playful';
  }


  /* ======================================================
     RECIPIENT
  ====================================================== */

  if (
    /\b(girlfriend|boyfriend|wife|husband|partner|fiance|fiancee|pritelkyne|pritelkyni|pritel|pritele|partnerka|partnerku|manzelka|manzelku|manzel|manzela)\b/.test(text)
  ) {
    answers.recipient =
      'partner';
  }

  else if (
    /\b(friend|bestie|bff)\b/.test(text)
  ) {
    answers.recipient =
      'friend';
  }

  else if (
    /\b(mom|mum|mother|dad|father|sister|brother|daughter|son|family)\b/.test(text)
  ) {
    answers.recipient =
      'family';
  }

  else if (
    /\b(for me|for myself|myself|me)\b/.test(text)
  ) {
    answers.recipient =
      'myself';
  }

  else if (
    /\b(gift|present)\b/.test(text)
  ) {
    answers.recipient =
      'gift';
  }

  /* ======================================================
   TAXONOMY CONCEPTS
====================================================== */

answers.taxonomyMatches =
  findNaturalLanguageTaxonomyMatches(
    input
  );


  /* ======================================================
     INITIALS
  ====================================================== */

  var initialsMatch =
    text.match(
      /\binitials?\s+([a-z])(?:\s*(?:and|&|,)\s*([a-z]))?/i
    );

  if (initialsMatch) {

    answers.initial1 =
      initialsMatch[1]
        .toUpperCase();

    if (initialsMatch[2]) {

      answers.initial2 =
        initialsMatch[2]
          .toUpperCase();

    }

  }


  /* ======================================================
     ZODIAC / BIRTHSTONE
  ====================================================== */

  ZODIACS.some(function (zodiac) {

  var matches =
    [zodiac.key, zodiac.label]
      .concat(zodiac.keywords || [])
      .some(function (keyword) {

        var normalizedKeyword =
          normalizeText(keyword)
            .replace(
              /[.*+?^${}()|[\]\\]/g,
              '\\$&'
            );

        var regex =
          new RegExp(
            '\\b' +
            normalizedKeyword +
            '\\b',
            'i'
          );

        return regex.test(text);

      });


  if (matches) {

    answers.zodiac =
      zodiac.key;

    return true;

  }


  return false;

});


  return answers;
}

function renderPromptUnderstanding(answers) {

  if (!promptUnderstood) {
    return;
  }

  promptUnderstood.replaceChildren();

  var title =
    document.createElement('div');

  title.className =
    'cb-prompt-understood-title';

  title.textContent =
    'I understood:';

  promptUnderstood.appendChild(title);


  var list =
    document.createElement('div');

  list.className =
    'cb-prompt-understood-list';


  function addRow(label, value, found) {

  var row =
    document.createElement('div');

  row.className =
    'cb-prompt-understood-row';


  var labelEl =
    document.createElement('span');

  labelEl.textContent =
    String(label || '');


  var valueEl =
    document.createElement('strong');

  valueEl.textContent =
    found
      ? String(value || '')
      : 'Not detected';


  row.appendChild(
    labelEl
  );

  row.appendChild(
    valueEl
  );


  if (!found) {

    row.classList.add(
      'is-missing'
    );

  }


  list.appendChild(
    row
  );
}


  addRow(
    'Jewelry',
    answers.jewelryType
      ? capitalize(answers.jewelryType)
      : '',
    !!answers.jewelryType
  );


  addRow(
    'Color',
    answers.metal
      ? capitalize(answers.metal)
      : '',
    !!answers.metal
  );


  addRow(
    'Style',
    answers.designWeight
      ? capitalize(answers.designWeight)
      : '',
    !!answers.designWeight
  );


  addRow(
    'For',
    answers.recipient
      ? getRecipientLabel(
          answers.recipient
        )
      : '',
    !!answers.recipient
  );


  addRow(
  'Matched motifs',

  answers.taxonomyMatches &&
  answers.taxonomyMatches.length

    ? answers.taxonomyMatches
        .map(function (match) {

          return (
            match.name +
            ' ← "' +
            match.matchedPhrase +
            '"'
          );

        })
        .join(', ')

    : '',

  !!(
    answers.taxonomyMatches &&
    answers.taxonomyMatches.length
  )
);


  addRow(
    'Initials',
    [
      answers.initial1,
      answers.initial2
    ]
      .filter(Boolean)
      .join(', '),
    !!(
      answers.initial1 ||
      answers.initial2
    )
  );


  addRow(
    'Birthstone',
    answers.zodiac
      ? getZodiacLabel(
          answers.zodiac
        )
      : '',
    !!answers.zodiac
  );


  promptUnderstood.appendChild(list);

  promptUnderstood.hidden = false;
}

function preloadImageUrl(url, width) {
  var largeUrl =
    makeLargeShopifyImageUrl(url, width || 1000);

  if (
    !largeUrl ||
    quizImagePreloadSet.has(largeUrl)
  ) {
    return;
  }

  quizImagePreloadSet.add(largeUrl);

  var img =
    new Image();

  img.decoding =
    'async';

  img.src =
    largeUrl;
}

function preloadQuizImagesOnce() {
  if (quizImagesPreloaded) {
    return;
  }

  quizImagesPreloaded = true;

  window.setTimeout(function () {
    refreshCharmDatabase();

    getAllBaseOptions().forEach(function (base) {
      if (base.image) {
        preloadImageUrl(base.image, 1200);
      }
    });

    /*
      Preload letters + birthstones.
      Do not preload all normal charms. That would be too much.
    */
    (window.charmDatabase || []).forEach(function (charm) {
      if (
        !charm ||
        !charm.image
      ) {
        return;
      }

      if (isReservedPersonalCharm(charm)) {
        preloadImageUrl(charm.image, 1000);
      }
    });
  }, 80);
}

function showDesignStart() {

  if (designStart) {
    designStart.hidden = false;
  }

  if (quizFlow) {
    quizFlow.hidden = true;
  }

  if (promptFlow) {
    promptFlow.hidden = true;
  }

}

function showPromptMode() {

  if (designStart) {
    designStart.hidden = true;
  }

  if (quizFlow) {
    quizFlow.hidden = true;
  }

  if (promptFlow) {
    promptFlow.hidden = false;
  }

  if (promptInput) {

    window.setTimeout(function () {
      promptInput.focus();
    }, 50);

  }

}

function showQuizMode() {

  if (designStart) {
    designStart.hidden = true;
  }

  if (promptFlow) {
    promptFlow.hidden = true;
  }

  if (quizFlow) {
    quizFlow.hidden = false;
  }

  /*
    Only restore a generated result here
    if that result actually came from the quiz.

    Prompt / AI prompt results must never
    appear as quiz results.
  */
  if (
    state.resultWasGenerated &&
    state.resultSource === 'quiz'
  ) {
    renderResults();
  } else {
    renderQuestion();
  }

  scrollQuizToTop();
}

  function openQuiz() {

  overlay.classList.add(
    'active'
  );

  overlay.setAttribute(
    'aria-hidden',
    'false'
  );


  refreshCharmDatabase();

  preloadQuizImagesOnce();


  showDesignStart();

}

  function closeQuiz() {
    if (overlay.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
  }

function getQuizScrollContainer() {
  return document.querySelector('.cb-quiz-content') || overlay;
}

function scrollQuizToTop() {
  var container =
    getQuizScrollContainer();

  if (container) {
    container.scrollTop = 0;
  }
}

function updateQuizProgress(percent) {
  var value =
    Math.max(0, Math.min(100, Number(percent) || 0));

  if (overlay) {
    overlay.style.setProperty(
      '--cb-progress',
      value + '%'
    );
  }

  if (progressFill) {
    progressFill.style.width =
      value + '%';
  }
}

function setQuizDirection(direction) {
  if (!overlay) {
    return;
  }

  overlay.classList.remove(
    'cb-quiz-direction-forward',
    'cb-quiz-direction-back'
  );

  overlay.classList.add(
    direction === 'back'
      ? 'cb-quiz-direction-back'
      : 'cb-quiz-direction-forward'
  );
}

function goToNextStep() {
  var question =
    QUESTIONS[state.step];

  if (!isQuestionAnswered(question)) {
    return;
  }

  scrollQuizToTop();

  if (state.step >= QUESTIONS.length - 1) {

  state.resultSource =
    'quiz';

  generateAndShowResults();

  return;
}

  state.step += 1;
setQuizDirection('forward');
renderQuestion();
scrollQuizToTop();
}

function autoContinueAfterSelection() {
  window.setTimeout(function () {
    goToNextStep();
  }, 220);
}

function scrollQuizToActions() {
  window.setTimeout(function () {
    var container =
      getQuizScrollContainer();

    if (
      !container ||
      !nextBtn
    ) {
      return;
    }

    var containerRect =
      container.getBoundingClientRect();

    var buttonRect =
      nextBtn.getBoundingClientRect();

    container.scrollTo({
      top:
        container.scrollTop +
        buttonRect.top -
        containerRect.top -
        40,
      behavior: 'smooth'
    });
  }, 80);
}

  function handleNext() {
  goToNextStep();
}

  function handlePrev() {

  /*
    BACK FROM RESULT VIEW
  */
  if (
    resultView &&
    !resultView.hidden
  ) {

    var source =
      state.resultSource;

    state.resultWasGenerated =
      false;

    resultView.hidden =
      true;


    /*
      Natural Language result:
      return to the prompt screen.

      promptInput is not cleared,
      so the customer's text stays there.
    */
    if (
      source === 'prompt' ||
      source === 'prompt-ai'
    ) {

      showPromptMode();
      return;

    }


    /*
      Normal Quiz result:
      return to the last quiz question.
    */
    optionsEl.hidden =
      false;

    nextBtn.hidden =
      false;

    prevBtn.textContent =
      'Back';

    setQuizDirection(
      'back'
    );

    renderQuestion();

    scrollQuizToTop();

    return;
  }


  /*
    BACK INSIDE NORMAL QUIZ
  */
  if (state.step === 0) {

    showDesignStart();
    return;

  }


  state.step -= 1;

  setQuizDirection(
    'back'
  );

  renderQuestion();

  scrollQuizToTop();
}

  function renderQuestion() {
    var question =
      QUESTIONS[state.step];

    resultView.hidden = true;
    optionsEl.hidden = false;
    nextBtn.hidden = false;

    titleEl.textContent =
      question.title;

    subtitleEl.textContent =
      question.subtitle || '';

    var progress =
      ((state.step + 1) / QUESTIONS.length) * 100;

    updateQuizProgress(progress);

    progressText.textContent =
      (state.step + 1) + ' / ' + QUESTIONS.length;

    optionsEl.replaceChildren();
    optionsEl.className = '';

    if (question.type === 'single') {
      renderSingleQuestion(question);
    }

    if (question.type === 'multi') {
      renderMultiQuestion(question);
    }

    if (question.type === 'letters') {
      renderLettersQuestion(question);
    }

    if (question.type === 'zodiac') {
      renderZodiacQuestion(question);
    }

    prevBtn.disabled = false;

    prevBtn.textContent =
      'Back';

    nextBtn.textContent =
      state.step === QUESTIONS.length - 1
        ? 'Show my designs'
        : 'Continue';

    updateNextButton();
  }

  function applyGridClass(question, optionCount) {
    optionsEl.classList.remove(
      'cb-options-grid-2',
      'cb-options-grid-3',
      'cb-options-grid-4',
      'cb-options-grid-letters',
      'cb-options-grid-zodiac'
    );

    if (question.layout === 'grid-2') {
      optionsEl.classList.add('cb-options-grid-2');
      return;
    }

    if (question.layout === 'grid-3') {
      optionsEl.classList.add('cb-options-grid-3');
      return;
    }

    if (question.layout === 'grid-4') {
      optionsEl.classList.add('cb-options-grid-4');
      return;
    }

    if (optionCount <= 2) {
      optionsEl.classList.add('cb-options-grid-2');
      return;
    }

    if (optionCount <= 6) {
      optionsEl.classList.add('cb-options-grid-3');
      return;
    }

    optionsEl.classList.add('cb-options-grid-4');
  }

  function renderSingleQuestion(question) {
  var optionList =
    getQuestionOptions(question);

  applyGridClass(question, optionList.length);

  optionList.forEach(function (option) {
    var cardClass = '';

    if (question.id === 'recipient') {
      cardClass = 'cb-recipient-card';
    }

    var card =
      createOptionCard(option, {
        active: state.answers[question.id] === option.value,
        className: cardClass
      });

    card.addEventListener('click', function () {
      state.answers[question.id] =
        option.value;

        if (
  question.id ===
  'designWeight'
) {

  state.answers.designWeightExplicit =
    true;

}

      if (question.id === 'metal') {
        delete state.answers.jewelryType;
        delete state.answers.designWeight;
        delete state.answers.designWeightExplicit;
        delete state.answers.initial1;
        delete state.answers.initial2;
        delete state.answers.zodiac;
      }

      if (question.id === 'jewelryType') {
        delete state.answers.designWeight;
        delete state.answers.designWeightExplicit;
      }

      renderQuestion();
      autoContinueAfterSelection();
    });

    optionsEl.appendChild(card);
  });
}

 function renderMultiQuestion(question) {
  var selected =
    Array.isArray(state.answers[question.id])
      ? state.answers[question.id]
      : [];

  var optionList =
    getQuestionOptions(question);

  applyGridClass(question, optionList.length);

  optionList.forEach(function (option) {
    var isActive =
      selected.indexOf(option.value) !== -1;

    var isDisabled =
      question.max &&
      selected.length >= question.max &&
      !isActive;

    var card =
      createOptionCard(option, {
        active: isActive,
        disabled: isDisabled,
        className: 'cb-interest-card'
      });

    card.addEventListener('click', function () {
      if (isDisabled) {
        return;
      }

      var current =
        Array.isArray(state.answers[question.id])
          ? state.answers[question.id].slice()
          : [];

      var exists =
        current.indexOf(option.value) !== -1;

      if (exists) {
        state.answers[question.id] =
          current.filter(function (value) {
            return value !== option.value;
          });
      } else {
        if (
          question.max &&
          current.length >= question.max
        ) {
          return;
        }

        current.push(option.value);
        state.answers[question.id] = current;
      }

      renderQuestion();

      if (
  question.max &&
  Array.isArray(state.answers[question.id]) &&
  state.answers[question.id].length >= question.max
) {
  scrollQuizToActions();
}

    });

    optionsEl.appendChild(card);
  });
}

function renderSkipRow(question, label) {
  var row =
    document.createElement('div');

  row.className =
    'cb-skip-row';

  var button =
    document.createElement('button');

  button.type =
    'button';

  button.className =
    'cb-skip-button';

  button.textContent =
    label || 'Skip this step';

  button.addEventListener('click', function () {
    state.answers[question.id] = '';
    renderQuestion();
    autoContinueAfterSelection();
  });

  row.appendChild(button);
  optionsEl.appendChild(row);
}

 function renderLettersQuestion(
  question
) {

  optionsEl.classList.add(
    'cb-options-grid-letters'
  );


  var metal =
    state.answers.metal ||
    'gold';


  /* ======================================================
     FIRST INITIAL

     Allow customer to skip ALL initials
     and jump directly to Birthstone.
  ====================================================== */

  if (
    question.id ===
    'initial1'
  ) {

    var skipRow =
      document.createElement(
        'div'
      );


    skipRow.className =
      'cb-skip-row';


    var skipButton =
      document.createElement(
        'button'
      );


    skipButton.type =
      'button';


    skipButton.className =
      'cb-skip-button';


    skipButton.textContent =
      'No initials, skip.';


    skipButton.addEventListener(
      'click',
      function () {

        /*
          Remove any previously selected
          initials in case the customer
          came back in the quiz.
        */

        delete state.answers.initial1;
        delete state.answers.initial2;


        /*
          Find Birthstone step.
        */

        var birthstoneIndex =
          QUESTIONS.findIndex(
            function (item) {

              return (
                item.id ===
                'zodiac'
              );

            }
          );


        if (
          birthstoneIndex === -1
        ) {
          return;
        }


        state.step =
          birthstoneIndex;


        setQuizDirection(
          'forward'
        );


        renderQuestion();


        scrollQuizToTop();

      }
    );


    skipRow.appendChild(
      skipButton
    );


    optionsEl.appendChild(
      skipRow
    );

  }


  /* ======================================================
     SECOND INITIAL

     Existing optional skip behavior.
  ====================================================== */

  if (
    question.id ===
      'initial2' &&
    question.optional
  ) {

    renderSkipRow(
      question,
      'Skip second initial'
    );

  }


  /* ======================================================
     LETTER OPTIONS
  ====================================================== */

  'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    .split('')
    .forEach(
      function (letter) {

        var letterCharm =
          findInitialCharm(
            letter,
            metal
          );


        var card =
          createOptionCard(
            {
              value:
                letter,

              label:
                letter,

              image:
                letterCharm
                  ? letterCharm.image
                  : ''
            },
            {
              active:
                state.answers[
                  question.id
                ] === letter,

              className:
                'cb-letter-card',

              compact:
                !letterCharm
            }
          );


        card.addEventListener(
          'click',
          function () {

            state.answers[
              question.id
            ] = letter;


            renderQuestion();


            autoContinueAfterSelection();

          }
        );


        optionsEl.appendChild(
          card
        );

      }
    );

}

 function renderZodiacQuestion(question) {
  optionsEl.classList.add('cb-options-grid-zodiac');

  var metal =
    state.answers.metal || 'gold';

  if (question.optional) {
    renderSkipRow(question, 'Skip birthstone');
  }

  ZODIACS.forEach(function (zodiac) {
    var birthstoneCharm =
      findZodiacCharm(zodiac.key, metal);

    var card =
      createOptionCard({
        value: zodiac.key,
        label: zodiac.label,
        subtitle: zodiac.dates,
        image: birthstoneCharm ? birthstoneCharm.image : ''
      }, {
        active: state.answers[question.id] === zodiac.key,
        className: 'cb-zodiac-card cb-birthstone-card',
        compact: !birthstoneCharm
      });

    card.addEventListener('click', function () {
      state.answers[question.id] = zodiac.key;
      renderQuestion();
      autoContinueAfterSelection();
    });

    optionsEl.appendChild(card);
  });
}

  function createOptionCard(option, settings) {
    var card =
      document.createElement('button');

    card.type = 'button';
    card.className = 'cb-option';

    if (
  settings &&
  settings.className
) {
  String(settings.className)
    .split(/\s+/)
    .filter(Boolean)
    .forEach(function (className) {
      card.classList.add(className);
    });
}

    if (
      settings &&
      settings.compact
    ) {
      card.classList.add('cb-option-compact');
    }

    if (
      settings &&
      settings.active
    ) {
      card.classList.add('active');
    }

    if (
  settings &&
  settings.disabled
) {
  card.disabled = true;
  card.classList.add('is-disabled');
}

    if (option.image) {
      var imageWrap =
        document.createElement('div');

      imageWrap.className =
        'cb-option-image';

      var img =
        document.createElement('img');

      img.src =
        makeLargeShopifyImageUrl(option.image, 1000);

      img.alt =
        option.label || '';

      img.loading =
        'lazy';

      img.decoding =
        'async';

      imageWrap.appendChild(img);
      card.appendChild(imageWrap);
    }

    var text =
      document.createElement('div');

    text.className =
      'cb-option-text';

    if (option.emoji) {
      var emoji =
        document.createElement('div');

      emoji.className =
        'cb-option-emoji';

      emoji.textContent =
        option.emoji;

      text.appendChild(emoji);
    }

    var label =
      document.createElement('div');

    label.className =
      'cb-option-label';

    label.textContent =
      option.label || option.value;

    text.appendChild(label);

    if (option.subtitle) {
      var subtitle =
        document.createElement('div');

      subtitle.className =
        'cb-option-subtitle';

      subtitle.textContent =
        option.subtitle;

      text.appendChild(subtitle);
    }

    card.appendChild(text);

    return card;
  }

  function getQuestionOptions(question) {
    if (typeof question.options === 'function') {
      return question.options();
    }

    return question.options || [];
  }

  function isQuestionAnswered(question) {
    var value =
      state.answers[question.id];

    if (question.optional) {
      return true;
    }

    if (question.type === 'multi') {
      return Array.isArray(value) && value.length > 0;
    }

    return (
      typeof value !== 'undefined' &&
      value !== ''
    );
  }

  function updateNextButton() {
    var question =
      QUESTIONS[state.step];

    nextBtn.disabled =
      !isQuestionAnswered(question);
  }

function getResultBackLabel() {

  if (
    state.resultSource === 'prompt' ||
    state.resultSource === 'prompt-ai'
  ) {
    return 'Back to prompt';
  }

  return 'Back to quiz';
}

  function generateAndShowResults() {
    refreshCharmDatabase();

    state.designs =
      generateDesigns(state.answers);

    state.activeDesignIndex = 0;
    state.resultWasGenerated = true;

    showDesignLoading(0);

    buildDesignSnapshotsSequentially();
  }

  function showDesignLoading(doneCount) {
    resultView.hidden = false;
    optionsEl.hidden = true;
    nextBtn.hidden = true;

    prevBtn.disabled = true;
    prevBtn.textContent =
  getResultBackLabel();

    titleEl.textContent =
      'Building your designs';

    subtitleEl.textContent =
      'We are creating 3 different charm mixes directly in the builder preview.';

    updateQuizProgress(100);

    progressText.textContent =
      'Loading';

    resultView.replaceChildren();

    var wrapper =
      document.createElement('div');

    wrapper.className =
      'cb-result-loading-screen';

    var title =
      document.createElement('div');

    title.className =
      'cb-result-loading-title';

    title.textContent =
      'Creating your charm designs…';

    var text =
      document.createElement('div');

    text.className =
      'cb-result-loading-text';

    text.textContent =
      'One moment. We are applying each design in the background and saving a real preview snapshot.';

    var steps =
      document.createElement('div');

    steps.className =
      'cb-result-loading-steps';

    [
      'Clean Story',
      'Personal Mix',
      'Statement Look'
    ].forEach(function (label, index) {
      var step =
        document.createElement('div');

      step.className =
        'cb-result-loading-step';

      if (index < doneCount) {
        step.classList.add('is-done');
      }

      if (index === doneCount) {
        step.classList.add('is-active');
      }

      step.textContent =
        index < doneCount
          ? label + ' ready'
          : (
              index === doneCount
                ? 'Creating ' + label
                : label
            );

      steps.appendChild(step);
    });

    wrapper.appendChild(title);
    wrapper.appendChild(text);
    wrapper.appendChild(steps);

    resultView.appendChild(wrapper);
  }

  function buildDesignSnapshotsSequentially() {
  var chain =
    Promise.resolve();

  state.designs.forEach(function (design, index) {
    chain = chain
      .then(function () {
        showDesignLoading(index);

        return applyDesignToBuilder(design);
      })
      .then(function () {
        return wait(350);
      })
      .then(function () {
        design.snapshotNode =
  captureBuilderPreviewSnapshot(
    design
  );

        showDesignLoading(index + 1);

        return wait(220);
      });
  });

  chain
    .then(function () {
      state.activeDesignIndex = 0;
      renderResults();
      scrollQuizToTop();
    })
    .catch(function (error) {
      console.warn('[Charm Bar Quiz] Could not build design snapshots:', error);
      renderResults();
      scrollQuizToTop();
    });
}

function changeResultDesign(direction) {
  if (!state.designs.length) {
    return;
  }

  var nextIndex =
    state.activeDesignIndex + direction;

  if (
    nextIndex < 0 ||
    nextIndex >= state.designs.length
  ) {
    return;
  }

  state.activeDesignIndex =
    nextIndex;

  renderResults();
}

function scrollActiveResultCard() {
  window.setTimeout(function () {
    var activeCard =
      resultView.querySelector(
        '[data-result-index="' + state.activeDesignIndex + '"]'
      );

    if (!activeCard) {
      return;
    }

    activeCard.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }, 40);
}

 function renderResults() {
  resultView.hidden = false;
  optionsEl.hidden = true;
  optionsEl.replaceChildren();
  nextBtn.hidden = true;

  prevBtn.disabled = false;
  prevBtn.textContent =
  getResultBackLabel();

  titleEl.textContent =
    'Choose your design';

  subtitleEl.textContent =
    'Swipe or use the arrows to compare your generated designs. The selected design is applied to the builder in the background.';

  updateQuizProgress(100);

  progressText.textContent =
    'Result';

  resultView.replaceChildren();

  var summary =
    createAnswersSummary();

  resultView.appendChild(summary);

  var carousel =
    document.createElement('div');

  carousel.className =
    'cb-result-carousel';

  var prevArrow =
    document.createElement('button');

  prevArrow.type =
    'button';

  prevArrow.className =
    'cb-result-arrow cb-result-arrow--prev';

    if (state.activeDesignIndex === 0) {
  prevArrow.disabled = true;
  prevArrow.classList.add('is-disabled');
}

  prevArrow.textContent =
    '‹';

  prevArrow.setAttribute(
    'aria-label',
    'Previous design'
  );

  prevArrow.addEventListener('click', function () {
    changeResultDesign(-1);
  });

  var nextArrow =
    document.createElement('button');

  nextArrow.type =
    'button';

  nextArrow.className =
    'cb-result-arrow cb-result-arrow--next';

    if (state.activeDesignIndex === state.designs.length - 1) {
  nextArrow.disabled = true;
  nextArrow.classList.add('is-disabled');
}

  nextArrow.textContent =
    '›';

  nextArrow.setAttribute(
    'aria-label',
    'Next design'
  );

  nextArrow.addEventListener('click', function () {
    changeResultDesign(1);
  });

  var viewport =
    document.createElement('div');

  viewport.className =
    'cb-result-carousel-viewport';

  var track =
    document.createElement('div');

  track.className =
    'cb-result-carousel-track';

  state.designs.forEach(function (design, index) {
    var card =
      document.createElement('div');

    card.className =
      'cb-result-card';

    card.setAttribute(
      'data-result-index',
      String(index)
    );

    if (index === state.activeDesignIndex) {
      card.classList.add('active');
    }

    var preview =
      document.createElement('button');

    preview.type =
      'button';

    preview.className =
      'cb-result-card-preview';

    preview.appendChild(
      renderSnapshotPreview(design)
    );

    preview.addEventListener('click', function () {
  state.activeDesignIndex = index;
  renderResults();
});

    var content =
      document.createElement('div');

    content.className =
      'cb-result-card-content';

    var pill =
      document.createElement('div');

    pill.className =
      'cb-result-pill';

    pill.textContent =
      'Option ' + (index + 1) + ' / 3';

    var heading =
      document.createElement('h3');

    heading.className =
      'cb-result-title';

    heading.textContent =
      design.title;

    var description =
      document.createElement('p');

    description.className =
      'cb-result-subtitle';

    description.textContent =
      design.subtitle;

    var meta =
      document.createElement('div');

    meta.className =
      'cb-result-meta';

    [
      design.baseLabel,
      design.charms.length + ' charms',
      state.answers.metal === 'gold' ? 'Gold' : 'Silver'
    ].forEach(function (text) {
      var span =
        document.createElement('span');

      span.textContent =
        text;

      meta.appendChild(span);
    });

    var price =
  document.createElement('div');

price.className =
  'cb-result-price';

price.textContent =
  formatKcPrice(
    getDesignTotalPrice(design)
  );

    var actions =
      document.createElement('div');

    actions.className =
      'cb-result-actions';

    var addToCart =
      document.createElement('button');

    addToCart.type =
      'button';

    addToCart.className =
      'cb-result-action cb-result-action-primary';

    addToCart.textContent =
      'Add to cart';

    addToCart.addEventListener('click', function () {
      state.activeDesignIndex = index;

      applyDesignToBuilder(design).then(function () {
        triggerBuilderAddToCart();
      });
    });

    var edit =
      document.createElement('button');

    edit.type =
      'button';

    edit.className =
      'cb-result-action cb-result-action-secondary';

    edit.textContent =
      'Edit this design';

    edit.addEventListener('click', function () {
      state.activeDesignIndex = index;

      applyDesignToBuilder(design).then(function () {
        closeQuiz();

        var builderPreview =
          document.querySelector('.charm_bar__preview');

        if (builderPreview) {
          builderPreview.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    });

    actions.appendChild(addToCart);
    actions.appendChild(edit);

    content.appendChild(pill);
content.appendChild(heading);
content.appendChild(description);
content.appendChild(meta);
content.appendChild(price);
content.appendChild(actions);

    card.appendChild(preview);
    card.appendChild(content);

    track.appendChild(card);
  });

  viewport.appendChild(track);

  carousel.appendChild(prevArrow);
  carousel.appendChild(viewport);
  carousel.appendChild(nextArrow);

  resultView.appendChild(carousel);

  var dots =
    document.createElement('div');

  dots.className =
    'cb-result-dots';

  state.designs.forEach(function (design, index) {
    var dot =
      document.createElement('button');

    dot.type =
      'button';

    dot.className =
      'cb-result-dot';

    if (index === state.activeDesignIndex) {
      dot.classList.add('active');
    }

    dot.setAttribute(
      'aria-label',
      'Show design ' + (index + 1)
    );

    dot.addEventListener('click', function () {
  state.activeDesignIndex = index;
  renderResults();
});

    dots.appendChild(dot);
  });

  resultView.appendChild(dots);

  scrollActiveResultCard();
}

  function createAnswersSummary() {
    var wrapper =
      document.createElement('div');

    wrapper.className =
      'cb-result-summary';

    var title =
      document.createElement('div');

    title.className =
      'cb-result-summary-title';

    title.textContent =
      'Your choices';

    var chips =
      document.createElement('div');

    chips.className =
      'cb-result-summary-chips';

    getAnswerChips().forEach(function (chip) {
      var span =
        document.createElement('span');

      span.textContent =
        chip;

      chips.appendChild(span);
    });

    wrapper.appendChild(title);
    wrapper.appendChild(chips);

    return wrapper;
  }

  function getAnswerChips() {
    var chips = [];

    if (state.answers.metal) {
      chips.push(
        'Metal: ' + capitalize(state.answers.metal)
      );
    }

    if (state.answers.jewelryType) {
      chips.push(
        'Type: ' + capitalize(state.answers.jewelryType)
      );
    }

    if (state.answers.designWeight) {
      chips.push(
        'Style: ' + capitalize(state.answers.designWeight)
      );
    }

    if (state.answers.recipient) {
      chips.push(
        'For: ' + getRecipientLabel(state.answers.recipient)
      );
    }

    if (
      Array.isArray(state.answers.interests) &&
      state.answers.interests.length
    ) {
      chips.push(
        'Likes: ' + state.answers.interests.map(getInterestLabel).join(', ')
      );
    }

    if (state.answers.initial1) {
      chips.push(
        'Initial: ' + state.answers.initial1
      );
    }

    if (state.answers.initial2) {
      chips.push(
        'Second initial: ' + state.answers.initial2
      );
    }

    if (state.answers.zodiac) {
  chips.push(
    'Birthstone: ' + getZodiacLabel(state.answers.zodiac)
  );
}

    return chips;
  }

  function getRecipientLabel(value) {
    var map = {
      myself: 'Myself',
      partner: 'My partner',
      friend: 'A friend',
      family: 'Family',
      gift: 'A gift'
    };

    return map[value] || value;
  }

  function getInterestLabel(value) {
    if (
      INTEREST_MAP[value] &&
      INTEREST_MAP[value].label
    ) {
      return INTEREST_MAP[value].label;
    }

    return value;
  }

  function getZodiacLabel(value) {
    var found =
      ZODIACS.find(function (item) {
        return item.key === value;
      });

    return found ? found.label : value;
  }

  function renderSnapshotPreview(design) {

  var preview;


  if (
    design &&
    design.snapshotNode
  ) {

    preview =
      design.snapshotNode.cloneNode(
        true
      );

  } else {

    preview =
      createDesignPreviewFallback(
        design
      );

  }


  if (
    isBraceletDesign(design)
  ) {

    preview.classList.add(
      'bracelet-preview'
    );

  } else {

    preview.classList.add(
      'necklace-preview'
    );

  }


  return preview;

}

function captureBuilderPreviewSnapshot(design) {
  var source =
    document.querySelector('.charm_bar__reference');

  if (!source) {
    return '';
  }

  var sourceWidth =
    source.offsetWidth || source.getBoundingClientRect().width || 360;

  var sourceHeight =
    source.offsetHeight || source.getBoundingClientRect().height || 450;

  var clone =
    source.cloneNode(true);

  if (isBraceletDesign(design)) {
    centerBraceletSnapshotCharms(clone);
  }

  cleanSnapshotClone(clone);

  clone.style.width =
    '100%';

  clone.style.height =
    '100%';

  clone.style.position =
    'relative';

  clone.style.transform =
    'none';

  clone.style.margin =
    '0';

  var wrapper =
    document.createElement('div');

  wrapper.className =
    'cb-live-preview-snapshot';

  wrapper.style.setProperty(
    '--cb-snapshot-ratio',
    sourceWidth + ' / ' + sourceHeight
  );

  wrapper.appendChild(
  clone
);

return wrapper;
}

function isBraceletDesign(design) {
  if (!design) {
    return false;
  }

  var text =
    normalizeText(
      [
        design.baseLabel || '',
        state.answers.jewelryType || ''
      ].join(' ')
    );

  return (
    text.indexOf('bracelet') !== -1 ||
    text.indexOf('naramek') !== -1
  );
}

function centerBraceletSnapshotCharms(clone) {
  var points =
    Array.from(
      clone.querySelectorAll('#charm_bar__points-layer [data-point-index]')
    )
      .map(function (point) {
        return {
          index: Number(point.dataset.pointIndex || 0),
          left: point.style.left || '',
          top: point.style.top || ''
        };
      })
      .filter(function (point) {
        return point.left && point.top;
      })
      .sort(function (a, b) {
        return a.index - b.index;
      });

  var charmWrappers =
    Array.from(
      clone.querySelectorAll('[data-preview-charm-placeholder="true"]')
    );

  if (!charmWrappers.length) {
    charmWrappers =
      Array.from(
        clone.querySelectorAll('draggable-element[data-preview-charm="true"]')
      ).map(function (el) {
        return el.parentElement || el;
      });
  }

  charmWrappers =
    charmWrappers.filter(function (el, index, arr) {
      return arr.indexOf(el) === index;
    });

  if (
    !points.length ||
    !charmWrappers.length
  ) {
    return;
  }

  var count =
    Math.min(charmWrappers.length, points.length);

  var startIndex =
    Math.max(
      0,
      Math.floor((points.length - count) / 2)
    );

  var centeredPoints =
    points.slice(startIndex, startIndex + count);

  charmWrappers.slice(0, count).forEach(function (wrapper, index) {
    var point =
      centeredPoints[index];

    wrapper.style.left =
      point.left;

    wrapper.style.top =
      point.top;

    var dragEl =
      wrapper.matches('draggable-element')
        ? wrapper
        : wrapper.querySelector('draggable-element[data-preview-charm="true"]');

    if (dragEl) {
      dragEl.setAttribute(
        'data-point-index',
        String(point.index)
      );
    }
  });
}

  function cleanSnapshotClone(clone) {
    replaceSnapshotDraggables(clone);

    Array.from(
      clone.querySelectorAll(
        [
          '.charm_bar__point',
          '.charm_bar__drop-area',
          '.charm-bar-fullscreen-button',
          '[data-drop-target]',
          '[data-save-design]',
          '[data-wishlist]',
          '[data-favorite]',
          '.save-bar',
          '.saved-bar',
          '.wishlist',
          '.wishlist-button',
          '.favorite-button',
          '.charm_bar__save',
          '.charm-bar__save',
          '.charm_bar__save-button',
          '.charm-bar__save-button',
          '.charm_bar__save-bar',
          '.charm-bar__save-bar'
        ].join(',')
      )
    ).forEach(function (el) {
      el.remove();
    });

    Array.from(
      clone.querySelectorAll('button')
    ).forEach(function (button) {
      button.remove();
    });

    Array.from(
      clone.querySelectorAll('*')
    ).forEach(function (el) {
      var className =
        typeof el.className === 'string'
          ? normalizeText(el.className)
          : '';

      var ariaLabel =
        normalizeText(el.getAttribute('aria-label') || '');

      if (
        className.indexOf('save') !== -1 ||
        className.indexOf('saved') !== -1 ||
        className.indexOf('wishlist') !== -1 ||
        className.indexOf('favorite') !== -1 ||
        ariaLabel.indexOf('save') !== -1 ||
        ariaLabel.indexOf('wishlist') !== -1 ||
        ariaLabel.indexOf('favorite') !== -1 ||
        ariaLabel.indexOf('uloz') !== -1
      ) {
        el.remove();
      }
    });

    Array.from(
      clone.querySelectorAll('[id]')
    ).forEach(function (el) {
      el.removeAttribute('id');
    });

    Array.from(
      clone.querySelectorAll('img')
    ).forEach(function (img) {
      if (img.src) {
        img.src =
          makeLargeShopifyImageUrl(img.src, 1200);
      }

      img.loading =
        'lazy';

      img.decoding =
        'async';
    });

    Array.from(
      clone.querySelectorAll('*')
    ).forEach(function (el) {
      el.removeAttribute('draggable');
      el.removeAttribute('tabindex');
      el.removeAttribute('role');

      el.style.pointerEvents = 'none';
      el.style.transition = 'none';
      el.style.animation = 'none';
    });
  }

  function replaceSnapshotDraggables(clone) {
    Array.from(
      clone.querySelectorAll('draggable-element[data-preview-charm="true"]')
    ).forEach(function (dragEl) {
      var replacement =
        document.createElement('div');

      replacement.className =
        dragEl.className || '';

      replacement.setAttribute(
        'data-preview-charm',
        'true'
      );

      replacement.setAttribute(
        'data-point-index',
        dragEl.getAttribute('data-point-index') || ''
      );

      replacement.style.cssText =
        dragEl.style.cssText;

      replacement.style.pointerEvents =
        'none';

      replacement.style.cursor =
        'default';

      while (dragEl.firstChild) {
        replacement.appendChild(
          dragEl.firstChild
        );
      }

      dragEl.replaceWith(replacement);
    });
  }

  function refreshCharmDatabase() {
    var seen =
      new Set();

    window.charmDatabase =
      Array.from(
        document.querySelectorAll(
          '.charm-bar__charm-item[data-product-variant-id], .charm_bar__charm-item[data-product-variant-id], article[data-product-variant-id][data-charm-name]'
        )
      )
        .map(function (charm) {
          var productId =
            charm.dataset.productId || '';

          var variantId =
            charm.dataset.productVariantId || '';

          if (
            !variantId ||
            seen.has(variantId)
          ) {
            return null;
          }

          seen.add(variantId);

          var name =
            charm.dataset.charmName || '';

          var image =
            getArticleImage(charm, 1000);

          var filterValues =
            charm.dataset.filterValues || '';

          var tags =
            window.CHARM_PRODUCT_TAGS &&
            window.CHARM_PRODUCT_TAGS[productId]
              ? window.CHARM_PRODUCT_TAGS[productId]
              : [];

          return {
  element: charm,
  productId: productId,
  variantId: variantId,
  name: name,
  nameClean: cleanCharmName(name),
  image: image,
  price: getElementPrice(charm),
  metal: detectMetal(name, image, filterValues),
  tags: tags,
  filterValues: filterValues
};
        })
        .filter(Boolean);
  }

  function cleanCharmName(name) {
    return String(name || '')
      .replace(/\s*-\s*Zlatá/gi, '')
      .replace(/\s*-\s*Stříbrná/gi, '')
      .replace(/\s*-\s*zlatá/gi, '')
      .replace(/\s*-\s*stříbrná/gi, '')
      .trim();
  }

  function detectMetal(name, image, filterValues) {
    var strongText =
      normalizeText([
        name,
        image
      ].join(' '));

    if (
      strongText.indexOf('stribr') !== -1 ||
      strongText.indexOf('silver') !== -1 ||
      strongText.indexOf('silv') !== -1
    ) {
      return 'silver';
    }

    if (
      strongText.indexOf('zlat') !== -1 ||
      strongText.indexOf('gold') !== -1
    ) {
      return 'gold';
    }

    var fallbackText =
      normalizeText(filterValues);

    if (
      fallbackText.indexOf('stribr') !== -1 &&
      fallbackText.indexOf('zlat') === -1
    ) {
      return 'silver';
    }

    return 'gold';
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function normalizeImageUrl(url) {
    if (!url) {
      return '';
    }

    var clean =
      String(url)
        .replace(/&amp;/g, '&')
        .trim();

    if (clean.indexOf('//') === 0) {
      clean =
        window.location.protocol + clean;
    }

    if (clean.indexOf('/') === 0) {
      clean =
        window.location.origin + clean;
    }

    return clean;
  }

  function makeLargeShopifyImageUrl(url, width) {
    var normalized =
      normalizeImageUrl(url);

    if (!normalized) {
      return '';
    }

    var targetWidth =
      width || 1000;

    try {
      var parsed =
        new URL(normalized, window.location.origin);

      parsed.searchParams.delete('width');
      parsed.searchParams.delete('height');
      parsed.searchParams.delete('crop');

      parsed.searchParams.set(
        'width',
        String(targetWidth)
      );

      return parsed.toString();
    } catch (error) {
      return normalized
        .replace(/([?&])(width|height|crop)=[^&]*/g, '')
        .replace(/[?&]$/, '');
    }
  }

  function getArticleImage(article, width) {
    if (!article) {
      return '';
    }

    var img =
      article.querySelector('draggable-element img') ||
      article.querySelector('img.charm-bar__product-image') ||
      article.querySelector('img.charm_bar__product-image') ||
      article.querySelector('img');

    var src =
      img && img.src
        ? img.src
        : (
            article.dataset.charmImageUrl ||
            ''
          );

    return makeLargeShopifyImageUrl(
      src,
      width || 1000
    );
  }

  function getAllBaseOptions() {
    return Array.from(
      document.querySelectorAll('.charm_bar__base-product-item, .charm-bar__base-product-item')
    ).map(function (item) {
      var span =
        item.querySelector('span');

      var img =
        item.querySelector('img');

      var label =
        span && span.textContent
          ? span.textContent.trim()
          : (
              item.textContent
                ? item.textContent.trim()
                : ''
            );

      var image =
        img && img.src
          ? makeLargeShopifyImageUrl(img.src, 1200)
          : '';

      var productId =
  item.dataset.baseProductId ||
  item.getAttribute(
    'data-base-product-id'
  ) ||
  '';

if (!productId) {

  var productIdElement =
    item.querySelector(
      '[data-product-id]'
    );

  if (productIdElement) {

    productId =
      productIdElement.dataset.productId ||
      productIdElement.getAttribute(
        'data-product-id'
      ) ||
      '';

  }

}

return {

  element:
    item,

  productId:
    String(productId || ''),

  label:
    label,

  labelNormalized:
    normalizeText(label),

  image:
    image,

  price:
    getElementPrice(item)

};
    });
  }

  function getBestBaseImage(keywords) {
    var bases =
      getAllBaseOptions();

    var normalizedKeywords =
      keywords.map(normalizeText);

    var found =
      bases.find(function (base) {
        return normalizedKeywords.some(function (keyword) {
          return base.labelNormalized.indexOf(keyword) !== -1;
        });
      });

    return found
      ? found.image
      : '';
  }

  function getBaseOptionForAnswers(answers) {
    var bases =
      getAllBaseOptions();

    var metal =
      answers.metal || 'gold';

    var jewelryType =
      answers.jewelryType || 'necklace';

    var designWeight =
      answers.designWeight || 'bold';

    var metalKeywords =
      metal === 'gold'
        ? ['zlaty', 'zlata', 'gold']
        : ['stribrny', 'stribrna', 'silver', 'silv'];

    var required = [];

    if (
      jewelryType === 'necklace' &&
      designWeight === 'bold'
    ) {
      required = ['nahrdelnik', 'rollo'];
    }

    if (
      jewelryType === 'necklace' &&
      designWeight === 'delicate'
    ) {
      required = ['nahrdelnik', 'paperclip'];
    }

    if (
      jewelryType === 'bracelet' &&
      designWeight === 'bold'
    ) {
      required = ['naramek', 'velky'];
    }

    if (
      jewelryType === 'bracelet' &&
      designWeight === 'delicate'
    ) {
      required = ['naramek', 'paperclip'];
    }

    if (
      jewelryType === 'bracelet' &&
      designWeight === 'playful'
    ) {
      required = ['naramek', 'srdce'];
    }

    var scored =
      bases
        .map(function (base) {
          var score = 0;

          required.forEach(function (keyword) {
            if (
              base.labelNormalized.indexOf(keyword) !== -1
            ) {
              score += 20;
            }
          });

          metalKeywords.forEach(function (keyword) {
            if (
              base.labelNormalized.indexOf(keyword) !== -1
            ) {
              score += 15;
            }
          });

          if (
            jewelryType === 'necklace' &&
            base.labelNormalized.indexOf('nahrdelnik') !== -1
          ) {
            score += 10;
          }

          if (
            jewelryType === 'bracelet' &&
            base.labelNormalized.indexOf('naramek') !== -1
          ) {
            score += 10;
          }

          return {
            base: base,
            score: score
          };
        })
        .sort(function (a, b) {
          return b.score - a.score;
        });

    return scored.length
      ? scored[0].base
      : null;
  }

  /* ==========================================================
   BASE DIVERSITY FOR GENERATED DESIGNS

   Explicit style:
   → respect the selected style
   → same matching base for all 3 designs

   No explicit style:
   → use different suitable bases where possible

   Metal + jewelry type always stay fixed.
========================================================== */

function getBaseIdentity(base) {

  if (!base) {
    return '';
  }


  return String(
    base.productId ||
    base.labelNormalized ||
    base.label ||
    ''
  );

}


function baseMatchesMetalAndType(
  base,
  answers
) {

  if (!base) {
    return false;
  }


  var label =
    base.labelNormalized ||
    normalizeText(
      base.label || ''
    );


  var metal =
    answers.metal ||
    'gold';


  var jewelryType =
    answers.jewelryType ||
    'necklace';


  var matchesMetal =
    metal === 'gold'
      ? (
          label.indexOf('zlat') !== -1 ||
          label.indexOf('gold') !== -1
        )
      : (
          label.indexOf('stribr') !== -1 ||
          label.indexOf('silver') !== -1 ||
          label.indexOf('silv') !== -1
        );


  var matchesType =
    jewelryType === 'necklace'
      ? (
          label.indexOf(
            'nahrdelnik'
          ) !== -1
        )
      : (
          label.indexOf(
            'naramek'
          ) !== -1
        );


  return (
    matchesMetal &&
    matchesType
  );

}


function getBasesForGeneratedDesigns(
  answers
) {

  /*
    User explicitly selected / requested
    delicate, bold or playful.

    Respect that choice.
  */

  if (
    answers.designWeightExplicit ===
    true
  ) {

    var explicitBase =
      getBaseOptionForAnswers(
        answers
      );


    return [
      explicitBase,
      explicitBase,
      explicitBase
    ];

  }


  /*
    No style was requested.

    Try different base styles.

    Order deliberately follows the
    three result concepts:

    Clean
    Personal
    Statement
  */

  var preferredStyles =
    answers.jewelryType ===
      'bracelet'
      ? [
          'delicate',
          'playful',
          'bold'
        ]
      : [
          'delicate',
          'bold'
        ];


  var uniqueBases = [];
  var usedBaseIds =
    new Set();


  function addUniqueBase(base) {

    if (
      !base ||
      !baseMatchesMetalAndType(
        base,
        answers
      )
    ) {
      return;
    }


    var identity =
      getBaseIdentity(
        base
      );


    if (
      !identity ||
      usedBaseIds.has(
        identity
      )
    ) {
      return;
    }


    usedBaseIds.add(
      identity
    );


    uniqueBases.push(
      base
    );

  }


  /*
    First use our known style mappings.
  */

  preferredStyles.forEach(
    function (style) {

      addUniqueBase(
        getBaseOptionForAnswers(
          Object.assign(
            {},
            answers,
            {
              designWeight:
                style
            }
          )
        )
      );

    }
  );


  /*
    If more matching bases exist,
    use them too.

    This automatically supports
    future bases without hardcoding them.
  */

  getAllBaseOptions()
    .forEach(function (base) {

      addUniqueBase(
        base
      );

    });


  /*
    Emergency fallback.
  */

  if (!uniqueBases.length) {

    var fallbackBase =
      getBaseOptionForAnswers(
        answers
      );


    if (fallbackBase) {

      uniqueBases.push(
        fallbackBase
      );

    }

  }


  if (!uniqueBases.length) {

    return [
      null,
      null,
      null
    ];

  }


  /*
    Return exactly three.

    If only 1 or 2 suitable bases exist,
    reuse them only after all unique ones
    have been used.
  */

  var result =
    uniqueBases.slice(
      0,
      3
    );


  var reusableBases =
    result.slice();


  var reuseIndex = 0;


  while (
    result.length < 3
  ) {

    result.push(
      reusableBases[
        reuseIndex %
        reusableBases.length
      ]
    );


    reuseIndex += 1;

  }


  return result;

}

  function getBaseOptionImage(answers) {
    var base =
      getBaseOptionForAnswers(answers);

    return base
      ? base.image
      : '';
  }

/* ==========================================================
   QUIZ RECOMMENDATION ENGINE
   No score system.

   Logic:
   1. Required personal charms
   2. One charm per selected interest
   3. One charm for recipient
   4. Random fillers
========================================================== */


function getNormalizedCharmTags(charm) {

  return (
    charm &&
    Array.isArray(charm.tags)
      ? charm.tags
      : []
  ).map(normalizeText);

}


function hasAnyTag(
  charmTags,
  wantedTags
) {

  if (
    !Array.isArray(charmTags) ||
    !Array.isArray(wantedTags) ||
    !wantedTags.length
  ) {
    return false;
  }


  return wantedTags.some(function (tag) {

    return charmTags.indexOf(
      normalizeText(tag)
    ) !== -1;

  });

}


/* ==========================================================
   PERSONAL CHARMS

   These must never appear as random filler.
========================================================== */

function isInitialCharm(charm) {

  if (!charm) {
    return false;
  }

  var tags =
    getNormalizedCharmTags(charm);


  /*
    Primary protection:
    canonical initial tags
  */

  if (
    tags.some(function (tag) {
      return /^motiv:pismeno-[a-z]$/.test(tag);
    })
  ) {
    return true;
  }


  /*
    Extra safety for older / incorrectly tagged products
  */

  var name =
    normalizeText(charm.name || '');


  return (
    /\bpismeno\s+[a-z]\b/.test(name) ||
    /\bpismenem\s+[a-z]\b/.test(name) ||
    /\bletter\s+[a-z]\b/.test(name) ||
    /\binitial\s+[a-z]\b/.test(name)
  );
}


function isBirthstoneCharm(charm) {

  if (!charm) {
    return false;
  }

  var tags =
    getNormalizedCharmTags(charm);


  /*
    Actual Shopify birthstone marker
  */

  if (
    tags.indexOf(
      'motiv:kamen-narozeni'
    ) !== -1
  ) {
    return true;
  }


  /*
    Newer zodiac taxonomy protection
  */

  if (
    tags.some(function (tag) {
      return tag.indexOf(
        'motiv:znameni-'
      ) === 0;
    })
  ) {
    return true;
  }


  /*
    Last-resort product-name protection
  */

  var name =
    normalizeText(charm.name || '');


  return (
    name.indexOf('birthstone') !== -1
  );
}


function isReservedPersonalCharm(charm) {

  return (
    isInitialCharm(charm) ||
    isBirthstoneCharm(charm)
  );

}


/* ==========================================================
   RANDOM HELPERS
========================================================== */

function shuffleArray(array) {

  var copy =
    array.slice();


  for (
    var i = copy.length - 1;
    i > 0;
    i -= 1
  ) {

    var j =
      Math.floor(
        Math.random() * (i + 1)
      );


    var temp =
      copy[i];

    copy[i] =
      copy[j];

    copy[j] =
      temp;

  }


  return copy;

}


/* ==========================================================
   SEMANTIC REQUIREMENTS

   Every item in this array should get ONE charm.
========================================================== */

function getQuizRequirements(answers) {

  var requirements = [];


  /*
    Selected interests.

    Each selected interest gets its own charm.
  */

  (answers.interests || []).forEach(
    function (interest) {

      var rule =
        INTEREST_MAP[interest];


      if (
        !rule ||
        !Array.isArray(rule.tags) ||
        !rule.tags.length
      ) {
        return;
      }


      requirements.push({

        id:
          'interest:' +
          interest,

        label:
          rule.label ||
          interest,

        type:
          'interest',

        value:
          interest,

        tags:
          rule.tags

      });

    }
  );

  /*
  Natural-language taxonomy concepts.

  Each detected concept gets ONE charm.
*/
(answers.taxonomyMatches || [])
  .forEach(function (match) {

    if (
      !match ||
      !match.key
    ) {
      return;
    }


    requirements.push({

      id:
        'taxonomy:' +
        match.key,

      label:
        match.name,

      type:
        'taxonomy',

      value:
        match.key,

      /*
        Exact request.
      */
      tags: [
        match.key
      ],

      /*
        Hierarchical fallback.
      */
      fallbackTags: [
        match.fallbackKey1,
        match.fallbackKey2
      ].filter(Boolean),

      matchedPhrase:
        match.matchedPhrase

    });

  });

  /*
    Recipient also gets ONE charm.

    Partner → Love
    Friend  → Friendship
    Family  → Family
    Myself  → Individuality / Self expression

    Gift has no specific semantic requirement.
  */

  var recipientRule =
  RECIPIENT_TAG_MAP[
    answers.recipient
  ] || null;


if (
  recipientRule &&
  Array.isArray(
    recipientRule.tags
  ) &&
  recipientRule.tags.length
) {

  requirements.push({

    id:
      'recipient:' +
      answers.recipient,

    label:
      answers.recipient,

    type:
      'recipient',

    value:
      answers.recipient,

    /*
      First-choice recipient meaning.
    */

    tags:
      recipientRule.tags,

    /*
      Ordered semantic fallbacks.
    */

    fallbackTags:
      Array.isArray(
        recipientRule.fallbackTags
      )
        ? recipientRule.fallbackTags
        : []

  });

}


  return requirements;

}


/* ==========================================================
   AVAILABLE CHARMS

   Correct metal only.
   No random initials / zodiac charms.
========================================================== */

function getRecommendationCharmPool(
  answers
) {

  refreshCharmDatabase();


  return (
    window.charmDatabase || []
  ).filter(function (charm) {

    return (
      charm &&
      charm.variantId &&
      charm.metal === answers.metal &&
      !isReservedPersonalCharm(charm)
    );

  });

}


/* ==========================================================
   PREPARE ONE GENERATION

   Candidate pools are shuffled ONCE.

   This allows Design 1 / 2 / 3 to use different candidates
   for Nature, Animals, Music, Partner, etc.
========================================================== */

function getCandidatesForTags(
  allCharms,
  tags
) {

  if (
    !Array.isArray(tags) ||
    !tags.length
  ) {
    return [];
  }


  return allCharms.filter(
    function (charm) {

      return hasAnyTag(
        getNormalizedCharmTags(
          charm
        ),
        tags
      );

    }
  );

}


function buildRequirementCandidatePool(
  requirement,
  allCharms
) {

  /*
    ======================================================
    1. EXACT MATCH
    ======================================================
  */

  var candidates =
    getCandidatesForTags(
      allCharms,
      requirement.tags
    );


  if (candidates.length) {

    return {

      requirement:
        requirement,

      candidates:
        shuffleArray(
          candidates
        ),

      matchLevel:
        'exact',

      matchedTags:
        requirement.tags.slice()

    };

  }


  /*
    Normal Quiz requirements do not necessarily
    have taxonomy fallback levels.
  */
  var fallbackTags =
    Array.isArray(
      requirement.fallbackTags
    )
      ? requirement.fallbackTags
      : [];


  /*
    ======================================================
    2. FALLBACK LEVEL 1
       e.g. Octopus → Aquatic animals
    ======================================================
  */

  if (fallbackTags[0]) {

    candidates =
      getCandidatesForTags(
        allCharms,
        [
          fallbackTags[0]
        ]
      );


    if (candidates.length) {

      return {

        requirement:
          requirement,

        candidates:
          shuffleArray(
            candidates
          ),

        matchLevel:
          'fallback-1',

        matchedTags: [
          fallbackTags[0]
        ]

      };

    }

  }


  /*
    ======================================================
    3. FALLBACK LEVEL 2
       e.g. Aquatic animals → Animals
    ======================================================
  */

  if (fallbackTags[1]) {

    candidates =
      getCandidatesForTags(
        allCharms,
        [
          fallbackTags[1]
        ]
      );


    if (candidates.length) {

      return {

        requirement:
          requirement,

        candidates:
          shuffleArray(
            candidates
          ),

        matchLevel:
          'fallback-2',

        matchedTags: [
          fallbackTags[1]
        ]

      };

    }

  }


  /*
    Nothing in exact or fallback hierarchy.
  */
  return {

    requirement:
      requirement,

    candidates:
      [],

    matchLevel:
      'none',

    matchedTags:
      []

  };

}

function createRecommendationContext(
  answers
) {

  var allCharms =
    getRecommendationCharmPool(
      answers
    );


  var requirements =
    getQuizRequirements(
      answers
    );


 var requirementPools =
  requirements.map(function (
    requirement
  ) {

    return buildRequirementCandidatePool(
      requirement,
      allCharms
    );

  });


  /*
    Random filler can come from ALL charms.

    Not only from selected interests.
  */

  var fillerPool =
  shuffleArray(
    allCharms.filter(
      function (charm) {

        var tags =
          getNormalizedCharmTags(
            charm
          );

        return !hasAnyTag(
          tags,
          [
            'tema:pratelstvi',
            'tema:laska',
            'tema:rodina',
            'tema:spojeni'
          ]
        );

      }
    )
  );


  /*
    Used only to maximize differences
    between the three designs.

    Reuse is still allowed if there are
    not enough candidates.
  */

  var usedAcrossDesigns =
    new Set();


  console.table(
  requirementPools.map(function (
    item
  ) {

    return {

      requested:
        item.requirement.label,

      heard:
        item.requirement.matchedPhrase ||
        '',

      requestedTag:
        (
          item.requirement.tags ||
          []
        ).join(', '),

      matchLevel:
        item.matchLevel,

      actuallyUsedTag:
        (
          item.matchedTags ||
          []
        ).join(', '),

      matchingCharms:
        item.candidates.length

    };

  })
);


  return {

    requirements:
      requirements,

    requirementPools:
      requirementPools,

    fillerPool:
      fillerPool,

    usedAcrossDesigns:
      usedAcrossDesigns

  };

}


/* ==========================================================
   PICK ONE CHARM FOR ONE SELECTED OPTION

   First tries a charm that has NOT appeared in another
   generated design.

   Only if necessary can it reuse one.
========================================================== */

function getCharmDiversityKey(charm) {

  if (!charm) {
    return '';
  }

  return String(
    charm.productId ||
    charm.variantId ||
    ''
  );
}

function pickRequirementCharm(
  context,
  requirementIndex,
  usedInCurrentDesign
) {

  var poolData =
    context.requirementPools[
      requirementIndex
    ];

  if (
    !poolData ||
    !poolData.candidates.length
  ) {

    console.warn(
      '[Charm Bar Quiz] No charm found for:',
      poolData
        ? poolData.requirement
        : requirementIndex
    );

    return null;
  }


  /*
    PASS 1:
    Prefer a PRODUCT that has not
    appeared in another design.
  */

  var freshCandidate =
    poolData.candidates.find(
      function (charm) {

        var key =
          getCharmDiversityKey(
            charm
          );

        return (
          key &&
          !usedInCurrentDesign.has(
            key
          ) &&
          !context.usedAcrossDesigns.has(
            key
          )
        );

      }
    );


  if (freshCandidate) {

    context.usedAcrossDesigns.add(
      getCharmDiversityKey(
        freshCandidate
      )
    );

    return freshCandidate;
  }


  /*
    PASS 2:
    Reuse across designs only if necessary,
    but never duplicate the same product
    inside one design.
  */

  var reusableCandidate =
    poolData.candidates.find(
      function (charm) {

        var key =
          getCharmDiversityKey(
            charm
          );

        return (
          key &&
          !usedInCurrentDesign.has(
            key
          )
        );

      }
    );


  if (reusableCandidate) {

    context.usedAcrossDesigns.add(
      getCharmDiversityKey(
        reusableCandidate
      )
    );

    return reusableCandidate;
  }


  return null;
}


/* ==========================================================
   RANDOM FILLER

   Can be ANY charm from the selected metal.

   First tries unused charms across all three designs.
========================================================== */

function pickRandomFillerCharm(
  context,
  usedInCurrentDesign
) {

  /*
    PASS 1:
    Completely fresh PRODUCT.
  */

  var fresh =
    context.fillerPool.find(
      function (charm) {

        var key =
          getCharmDiversityKey(
            charm
          );

        return (
          key &&
          !usedInCurrentDesign.has(
            key
          ) &&
          !context.usedAcrossDesigns.has(
            key
          )
        );

      }
    );


  if (fresh) {

    context.usedAcrossDesigns.add(
      getCharmDiversityKey(
        fresh
      )
    );

    return fresh;
  }


  /*
    PASS 2:
    Reuse across designs only if needed.
  */

  var reusable =
    context.fillerPool.find(
      function (charm) {

        var key =
          getCharmDiversityKey(
            charm
          );

        return (
          key &&
          !usedInCurrentDesign.has(
            key
          )
        );

      }
    );


  if (reusable) {

    context.usedAcrossDesigns.add(
      getCharmDiversityKey(
        reusable
      )
    );

    return reusable;
  }


  return null;
}

/* ==========================================================
   BUILDER POSITION RULES
========================================================== */

var BUILDER_CENTER_POSITION_TAG =
  'builder:position-center';


function shouldCenterCharm(charm) {

  if (!charm) {
    return false;
  }


  return (
    getNormalizedCharmTags(charm)
      .indexOf(
        BUILDER_CENTER_POSITION_TAG
      ) !== -1
  );

}


/* ==========================================================
   GET REAL BUILDER ANCHORS
========================================================== */

function getBuilderAnchorPoints() {

  return Array.from(
    document.querySelectorAll(
      '#charm_bar__points-layer ' +
      '[data-point-index][data-drop-target]'
    )
  ).map(function (element) {

    return {

      element:
        element,

      index:
        String(
          element.dataset.pointIndex
        )

    };

  });

}


/* ==========================================================
   CENTER ANCHOR

   Necklace:
   always Anchor 0.

   Bracelet:
   middle numerical Anchor.

   7 anchors → 3
   8 anchors → 4
   9 anchors → 4
========================================================== */

function getCenterBuilderAnchor(
  answers,
  anchorPoints
) {

  if (
    !Array.isArray(anchorPoints) ||
    !anchorPoints.length
  ) {
    return null;
  }


  /*
    Necklace center is explicitly
    defined as Anchor 0.
  */

  if (
    answers &&
    answers.jewelryType ===
      'necklace'
  ) {

    return (
      anchorPoints.find(
        function (point) {

          return (
            String(point.index) ===
            '0'
          );

        }
      ) ||
      null
    );

  }


  /*
    Bracelet:
    choose the middle numerical index.
  */

  var sorted =
    anchorPoints
      .slice()
      .sort(function (a, b) {

        return (
          Number(a.index) -
          Number(b.index)
        );

      });


  return (
    sorted[
      Math.floor(
        sorted.length / 2
      )
    ] ||
    null
  );

}


/* ==========================================================
   FIND THE REAL BUILDER DRAGGABLE
========================================================== */

function getCharmBuilderDraggable(
  charm
) {

  if (
    !charm ||
    !charm.variantId
  ) {
    return null;
  }


  var selector =
    '.charm-bar__charm-item' +
    '[data-product-variant-id="' +
    charm.variantId +
    '"],' +
    '.charm_bar__charm-item' +
    '[data-product-variant-id="' +
    charm.variantId +
    '"]';


  var item =
    document.querySelector(
      selector
    );


  if (!item) {
    return null;
  }


  return (
    item.querySelector(
      'draggable-element'
    ) ||
    null
  );

}


/* ==========================================================
   DROP ONE CHARM ON ONE EXACT ANCHOR

   Uses the Builder's own native x-drop event.
========================================================== */

function dropCharmOnBuilderAnchor(
  charm,
  anchorPoint
) {

  if (
    !charm ||
    !anchorPoint ||
    !anchorPoint.element
  ) {
    return Promise.resolve();
  }


  var draggable =
    getCharmBuilderDraggable(
      charm
    );


  if (!draggable) {

    console.warn(
      '[Charm Bar Quiz] Builder draggable not found:',
      charm
    );

    return Promise.resolve();

  }


  var event =
    new CustomEvent(
      'x-drop',
      {
        bubbles:
          true,

        composed:
          true,

        detail: {

          /*
            The Builder accepts either
            draggable or draggedElement.
            Give it both.
          */

          draggable:
            draggable,

          draggedElement:
            draggable

        }
      }
    );


  anchorPoint.element.dispatchEvent(
    event
  );


  return wait(95);

}


/* ==========================================================
   BUILD RANDOM ANCHOR PLAN

   - center-tagged Charm reserves center
   - all remaining Charms randomized
   - all remaining Anchors randomized
========================================================== */

function createBuilderAnchorPlan(
  design
) {

  var charms =
    design &&
    Array.isArray(design.charms)
      ? design.charms.slice()
      : [];


  var anchors =
  getBuilderAnchorPoints()
    .slice()
    .sort(function (a, b) {

      return (
        Number(a.index) -
        Number(b.index)
      );

    });


/*
  The generated design must only use the
  anchors covered by the configured base capacity.

  Example:

  Necklace may physically expose:
  0–11

  Generated design capacity:
  9

  Therefore automatic designs only use:
  0–8

  The additional outer anchors remain available
  for manual editing by the customer.
*/

var allowedAnchorCount =
  limitForDesign(
    state.answers,
    design && design.base
      ? design.base
      : null
  );


if (
  Number.isFinite(
    allowedAnchorCount
  ) &&
  allowedAnchorCount > 0 &&
  anchors.length >
    allowedAnchorCount
) {

  anchors =
    anchors.slice(
      0,
      allowedAnchorCount
    );

}


if (
  !charms.length ||
  !anchors.length
) {
  return [];
}

/*
  Reuse the anchor assignment once this
  generated design already has one.

  This keeps:
  result preview
  edit
  add to cart

  visually identical.
*/

if (
  Array.isArray(
    design.anchorAssignments
  ) &&
  design.anchorAssignments.length
) {

  var restoredPlan =
    design.anchorAssignments
      .map(function (saved) {

        var charm =
          charms.find(
            function (charm) {

              return (
                String(
                  charm.variantId
                ) ===
                String(
                  saved.variantId
                )
              );

            }
          );


        var anchor =
          anchors.find(
            function (anchor) {

              return (
                String(
                  anchor.index
                ) ===
                String(
                  saved.anchorIndex
                )
              );

            }
          );


        if (
          !charm ||
          !anchor
        ) {
          return null;
        }


        return {
          charm:
            charm,

          anchor:
            anchor
        };

      })
      .filter(Boolean);


  if (
    restoredPlan.length ===
    charms.length
  ) {

    return restoredPlan;

  }


  /*
    Something changed in the design/base.
    Generate a fresh assignment.
  */

  design.anchorAssignments = [];

}

  var centerCharms =
    shuffleArray(
      charms.filter(
        function (charm) {

          return shouldCenterCharm(
            charm
          );

        }
      )
    );


  var normalCharms =
    charms.filter(
      function (charm) {

        return !shouldCenterCharm(
          charm
        );

      }
    );


  var plan = [];


  /* ======================================================
     CENTER CHARM

     If several center-tagged Charms somehow appear,
     one gets the true center.

     The others join the normal random placement.
  ====================================================== */

  if (centerCharms.length) {

    var centerAnchor =
      getCenterBuilderAnchor(
        state.answers,
        anchors
      );


    if (centerAnchor) {

      var centerCharm =
        centerCharms.shift();


      plan.push({

        charm:
          centerCharm,

        anchor:
          centerAnchor

      });


      anchors =
        anchors.filter(
          function (point) {

            return (
              String(point.index) !==
              String(
                centerAnchor.index
              )
            );

          }
        );

    }

  }


  /* ======================================================
     EVERYTHING ELSE

     Random charm order +
     random anchor order.
  ====================================================== */

  var remainingCharms =
    shuffleArray(
      normalCharms.concat(
        centerCharms
      )
    );


  var remainingAnchors =
    shuffleArray(
      anchors
    );


  remainingCharms.forEach(
    function (
      charm,
      index
    ) {

      var anchor =
        remainingAnchors[
          index
        ];


      if (!anchor) {
        return;
      }


      plan.push({

        charm:
          charm,

        anchor:
          anchor

      });

    }
  );


  /*
  Store only IDs/indexes.

  Never store the DOM elements themselves,
  because the Builder recreates anchor elements
  when bases are changed.
*/

design.anchorAssignments =
  plan.map(function (placement) {

    return {

      variantId:
        String(
          placement.charm.variantId
        ),

      anchorIndex:
        String(
          placement.anchor.index
        )

    };

  });


return plan;

}


/* ==========================================================
   APPLY ALL CHARMS TO EXACT ANCHORS
========================================================== */

function applyDesignCharmsToAnchors(
  design
) {

  var plan =
    createBuilderAnchorPlan(
      design
    );


  /*
    Emergency fallback:

    If the Builder's anchor DOM was not available,
    retain the old + button behavior instead of
    failing completely.
  */

  if (
    !plan.length &&
    design &&
    Array.isArray(design.charms) &&
    design.charms.length
  ) {

    console.warn(
      '[Charm Bar Quiz] Anchor points unavailable. ' +
      'Using sequential fallback.'
    );


    var fallbackChain =
      Promise.resolve();


    design.charms.forEach(
      function (charm) {

        fallbackChain =
          fallbackChain.then(
            function () {

              return addCharmToBuilder(
                charm
              );

            }
          );

      }
    );


    return fallbackChain;

  }


  if (
    design &&
    Array.isArray(design.charms) &&
    plan.length <
      design.charms.length
  ) {

    console.warn(
      '[Charm Bar Quiz] Not enough anchor points:',
      {
        charms:
          design.charms.length,

        anchors:
          plan.length
      }
    );

  }


  var chain =
    Promise.resolve();


  plan.forEach(
    function (placement) {

      chain =
        chain.then(
          function () {

            return dropCharmOnBuilderAnchor(
              placement.charm,
              placement.anchor
            );

          }
        );

    }
  );


  return chain;

}


/* ==========================================================
   BUILD ONE DESIGN
========================================================== */

function buildQuizDesignCharms(
  requiredCharms,
  context,
  limit
) {

  var selected = [];

  var usedInCurrentDesign =
    new Set();


  function addCharm(charm) {

  var diversityKey =
    getCharmDiversityKey(
      charm
    );

  if (
    !charm ||
    !charm.variantId ||
    !diversityKey ||
    usedInCurrentDesign.has(
      diversityKey
    ) ||
    selected.length >= limit
  ) {

    return false;
  }


  selected.push(
    charm
  );


  usedInCurrentDesign.add(
    diversityKey
  );


  return true;
}


  /* ======================================================
     1. INITIALS + BIRTHSTONE

     requiredCharms is already created as:

     initial1
     initial2
     birthstone

     Therefore this order also defines priority.
  ====================================================== */

  uniqueCharms(
    requiredCharms
  ).forEach(function (charm) {

    if (
      selected.length >= limit
    ) {
      return;
    }


    addCharm(
      charm
    );

  });


  /* ======================================================
     SPLIT SEMANTIC REQUIREMENTS

     Recipient has higher priority than
     interests / AI concepts.
  ====================================================== */

  var recipientRequirementIndexes =
    [];

  var conceptRequirementIndexes =
    [];


  context.requirements.forEach(
    function (
      requirement,
      requirementIndex
    ) {

      if (
        requirement &&
        requirement.type ===
          'recipient'
      ) {

        recipientRequirementIndexes.push(
          requirementIndex
        );

        return;

      }


      /*
        Everything else represents a
        semantic choice / concept:

        - AI taxonomy concepts
        - normal Quiz interests
      */

      conceptRequirementIndexes.push(
        requirementIndex
      );

    }
  );


  /* ======================================================
     2. RECIPIENT

     Always before concepts.
  ====================================================== */

  recipientRequirementIndexes.forEach(
    function (
      requirementIndex
    ) {

      if (
        selected.length >= limit
      ) {
        return;
      }


      var charm =
        pickRequirementCharm(
          context,
          requirementIndex,
          usedInCurrentDesign
        );


      if (charm) {

        addCharm(
          charm
        );

      } else {

        console.warn(
          '[Charm Bar Quiz] Could not satisfy recipient:',
          context.requirements[
            requirementIndex
          ]
        );

      }

    }
  );


  /* ======================================================
     3. CONCEPTS

     IMPORTANT:

     Shuffle the requirements themselves.

     Therefore if there are more concepts than
     available anchor points, a RANDOM subset
     gets selected for this design.

     buildQuizDesignCharms() runs separately
     for Design 1 / 2 / 3, so each design gets
     a fresh random concept order.
  ====================================================== */

  var randomizedConceptIndexes =
    shuffleArray(
      conceptRequirementIndexes
    );


  randomizedConceptIndexes.forEach(
    function (
      requirementIndex
    ) {

      /*
        Capacity reached.

        Remaining concepts are intentionally
        ignored for this design.
      */

      if (
        selected.length >= limit
      ) {
        return;
      }


      var requirement =
        context.requirements[
          requirementIndex
        ];


      var charm =
        pickRequirementCharm(
          context,
          requirementIndex,
          usedInCurrentDesign
        );


      if (charm) {

        addCharm(
          charm
        );

      } else {

        console.warn(
          '[Charm Bar Quiz] Could not satisfy selected concept:',
          requirement
        );

      }

    }
  );


  /* ======================================================
     4. RANDOM FILLERS

     Only when there is still capacity after:

     initials
     birthstone
     recipient
     concepts
  ====================================================== */

  while (
    selected.length < limit
  ) {

    var filler =
      pickRandomFillerCharm(
        context,
        usedInCurrentDesign
      );


    if (!filler) {
      break;
    }


    addCharm(
      filler
    );

  }


  /* ======================================================
     5. PHYSICAL ANCHOR ORDER

     Semantic priority above decides WHICH
     charms survive.

     It must NOT decide WHERE they appear.

     Therefore physical positions are randomized
     only after the final selection is complete.
  ====================================================== */

  var finalCharms =
  selected.slice(
    0,
    limit
  );


/*
  Selection and physical placement
  are deliberately separate.

  Anchor positions are assigned later
  when the design is applied.
*/

return finalCharms;

}

 function findInitialCharm(letter, metal) {

  if (!letter) {
    return null;
  }

  refreshCharmDatabase();


  var normalizedLetter =
    normalizeText(letter);


  /*
    Primary lookup:
    exact canonical taxonomy tag
  */

  var expectedTag =
    'motiv:pismeno-' +
    normalizedLetter;


  var exactByTag =
    (window.charmDatabase || [])
      .find(function (charm) {

        return (
          charm.metal === metal &&
          getNormalizedCharmTags(charm)
            .indexOf(expectedTag) !== -1
        );

      });


  if (exactByTag) {
    return exactByTag;
  }


  /*
    Fallback only in case an old product
    temporarily has no canonical tag.
  */

  return (
    window.charmDatabase || []
  ).find(function (charm) {

    var name =
      normalizeText(charm.name);

    return (
      charm.metal === metal &&
      (
        name.indexOf(
          'pismenem ' + normalizedLetter
        ) !== -1 ||

        name.indexOf(
          'pismeno ' + normalizedLetter
        ) !== -1 ||

        name.indexOf(
          'letter ' + normalizedLetter
        ) !== -1 ||

        name.indexOf(
          'initial ' + normalizedLetter
        ) !== -1
      )
    );

  }) || null;
}

  function findZodiacCharm(zodiacKey, metal) {

  if (!zodiacKey) {
    return null;
  }


  refreshCharmDatabase();


  var zodiac =
    ZODIACS.find(function (item) {
      return item.key === zodiacKey;
    });


  if (!zodiac) {
    return null;
  }


  /*
    Primary lookup:
    exact taxonomy tag
  */

  var expectedTag =
    normalizeText(zodiac.tag);


  var exactByTag =
    (window.charmDatabase || [])
      .find(function (charm) {

        return (
          charm.metal === metal &&
          getNormalizedCharmTags(charm)
            .indexOf(expectedTag) !== -1
        );

      });


  if (exactByTag) {
    return exactByTag;
  }


  /*
    Fallback for temporarily untagged old products
  */

  return (
    window.charmDatabase || []
  ).find(function (charm) {

    var name =
      normalizeText(charm.name);

    return (
      charm.metal === metal &&
      zodiac.keywords.some(function (keyword) {

        return name.indexOf(
          normalizeText(keyword)
        ) !== -1;

      })
    );

  }) || null;
}

  function uniqueCharms(charms) {
    var seen =
      new Set();

    return charms.filter(function (charm) {
      if (
        !charm ||
        !charm.variantId
      ) {
        return false;
      }

      if (seen.has(charm.variantId)) {
        return false;
      }

      seen.add(charm.variantId);

      return true;
    });
  }

function limitForDesign(
  answers,
  base
) {

  /*
    ======================================================
    NECKLACES
    ======================================================

    All necklace bases currently support
    up to 9 charms.
  */

  if (
    answers.jewelryType ===
    'necklace'
  ) {

    return 9;

  }


  /*
    ======================================================
    BRACELETS
    ======================================================
  */

  var productId =
    base && base.productId
      ? String(base.productId)
      : '';


  /*
    Standard / large bracelet
    7 anchor points
  */

  if (
    productId ===
    '15463395557751'
  ) {

    return 7;

  }


  /*
    Paperclip bracelet
    8 anchor points
  */

  if (
    productId ===
    '15463369310583'
  ) {

    return 8;

  }


  /*
    Heart bracelet
    9 anchor points
  */

  if (
    productId ===
    '15463308558711'
  ) {

    return 9;

  }


  /*
    ======================================================
    FALLBACK

    In case the app DOM does not expose the product ID,
    use the already known base label.

    This prevents us from accidentally limiting
    Paperclip / Heart bracelets to 7.
  */

  var label =
    base &&
    base.labelNormalized
      ? base.labelNormalized
      : '';


  if (
    label.indexOf(
      'paperclip'
    ) !== -1
  ) {

    return 8;

  }


  if (
    label.indexOf(
      'srdce'
    ) !== -1
  ) {

    return 9;

  }


  /*
    Safest default for an unknown bracelet:
    never generate more than 7.
  */

  return 7;

}

/* ==========================================================
   DEBUG GENERATED DESIGNS

   Run manually in DevTools:
   CB_DEBUG_DESIGNS()

   Reads only.
   Does NOT generate or change anchor assignments.
========================================================== */

window.CB_DEBUG_DESIGNS = function () {

  var designs =
    Array.isArray(state.designs)
      ? state.designs
      : [];


  if (!designs.length) {

    console.warn(
      '[Charm Bar Debug] No generated designs available yet.'
    );

    return [];
  }


  var answers =
    state.answers || {};


  var report =
    designs.map(function (
      design,
      designIndex
    ) {

      var charms =
        design &&
        Array.isArray(design.charms)
          ? design.charms
          : [];


      var assignments =
        design &&
        Array.isArray(
          design.anchorAssignments
        )
          ? design.anchorAssignments
          : [];


      var capacity =
        limitForDesign(
          answers,
          design && design.base
            ? design.base
            : null
        );


      var selectedVariantIds =
        charms.map(function (charm) {

          return String(
            charm.variantId || ''
          );

        });


      var assignmentVariantIds =
        assignments.map(function (
          assignment
        ) {

          return String(
            assignment.variantId || ''
          );

        });


      var anchorIndexes =
        assignments.map(function (
          assignment
        ) {

          return String(
            assignment.anchorIndex
          );

        });


      /* -----------------------------
         DUPLICATE ANCHORS
      ----------------------------- */

      var duplicateAnchors =
        anchorIndexes.filter(function (
          value,
          index,
          array
        ) {

          return (
            array.indexOf(value) !==
            index
          );

        });


      duplicateAnchors =
        Array.from(
          new Set(
            duplicateAnchors
          )
        );


      /* -----------------------------
         DUPLICATE CHARMS
      ----------------------------- */

      var duplicateVariants =
        selectedVariantIds.filter(
          function (
            value,
            index,
            array
          ) {

            return (
              value &&
              array.indexOf(value) !==
                index
            );

          }
        );


      duplicateVariants =
        Array.from(
          new Set(
            duplicateVariants
          )
        );


      /* -----------------------------
         MISSING ASSIGNMENTS
      ----------------------------- */

      var unassignedCharms =
        charms.filter(function (charm) {

          return (
            assignmentVariantIds
              .indexOf(
                String(
                  charm.variantId || ''
                )
              ) === -1
          );

        });


      /* -----------------------------
         UNKNOWN ASSIGNMENTS
      ----------------------------- */

      var unknownAssignments =
        assignments.filter(
          function (assignment) {

            return (
              selectedVariantIds
                .indexOf(
                  String(
                    assignment.variantId ||
                    ''
                  )
                ) === -1
            );

          }
        );


      /* -----------------------------
         CAPACITY / ANCHOR RANGE
      ----------------------------- */

      var invalidAnchors =
        assignments.filter(
          function (assignment) {

            var anchorIndex =
              Number(
                assignment.anchorIndex
              );

            return (
              !Number.isFinite(
                anchorIndex
              ) ||
              anchorIndex < 0 ||
              anchorIndex >= capacity
            );

          }
        );


      /* -----------------------------
         METAL
      ----------------------------- */

      var wrongMetalCharms =
        charms.filter(
          function (charm) {

            return (
              answers.metal &&
              charm.metal &&
              charm.metal !==
                answers.metal
            );

          }
        );


      /* -----------------------------
         CENTER RULE

         Necklace:
         anchor 0

         Bracelet:
         middle of capacity
         7 -> 3
         8 -> 4
         9 -> 4
      ----------------------------- */

      var centerTaggedCharms =
        charms.filter(
          function (charm) {

            return shouldCenterCharm(
              charm
            );

          }
        );


      var expectedCenterAnchor =
        answers.jewelryType ===
          'necklace'
          ? '0'
          : String(
              Math.floor(
                capacity / 2
              )
            );


      var centerAssignment =
        assignments.find(
          function (assignment) {

            return (
              String(
                assignment.anchorIndex
              ) ===
              expectedCenterAnchor
            );

          }
        );


      var centerCharm =
        centerAssignment
          ? charms.find(
              function (charm) {

                return (
                  String(
                    charm.variantId ||
                    ''
                  ) ===
                  String(
                    centerAssignment
                      .variantId ||
                    ''
                  )
                );

              }
            )
          : null;


      var centerRuleOk =
        !centerTaggedCharms.length ||
        !!(
          centerCharm &&
          shouldCenterCharm(
            centerCharm
          )
        );


      /* -----------------------------
         CHECKS
      ----------------------------- */

      var checks = {

        capacity:
          charms.length <=
          capacity,

        assignmentCount:
          assignments.length ===
          charms.length,

        duplicateAnchors:
          duplicateAnchors.length ===
          0,

        duplicateVariants:
          duplicateVariants.length ===
          0,

        allCharmsAssigned:
          unassignedCharms.length ===
          0,

        noUnknownAssignments:
          unknownAssignments.length ===
          0,

        anchorsWithinCapacity:
          invalidAnchors.length ===
          0,

        correctCharmMetal:
          wrongMetalCharms.length ===
          0,

        baseMatchesSelection:
          !!(
            design &&
            design.base &&
            baseMatchesMetalAndType(
              design.base,
              answers
            )
          ),

        centerRule:
          centerRuleOk

      };


      var allChecksPass =
        Object.keys(checks)
          .every(function (key) {

            return (
              checks[key] === true
            );

          });


      /* -----------------------------
         PRODUCT / ANCHOR TABLE

         Build this from selected charms,
         not assignments, so a missing
         assignment is visible too.
      ----------------------------- */

      var rows =
        charms.map(function (charm) {

          var assignment =
            assignments.find(
              function (saved) {

                return (
                  String(
                    saved.variantId ||
                    ''
                  ) ===
                  String(
                    charm.variantId ||
                    ''
                  )
                );

              }
            );


          var anchorIndex =
            assignment
              ? String(
                  assignment.anchorIndex
                )
              : 'MISSING';


          return {

            Anchor:
              anchorIndex,

            Charm:
              charm.nameClean ||
              charm.name ||
              'Unnamed charm',

            ProductID:
              String(
                charm.productId || ''
              ),

            VariantID:
              String(
                charm.variantId || ''
              ),

            Metal:
              charm.metal || '',

            CenterTagged:
              shouldCenterCharm(
                charm
              )
                ? 'YES'
                : '',

            ExpectedCenter:
              anchorIndex ===
              expectedCenterAnchor
                ? 'YES'
                : ''

          };

        });


      rows.sort(function (a, b) {

        if (a.Anchor === 'MISSING') {
          return 1;
        }

        if (b.Anchor === 'MISSING') {
          return -1;
        }

        return (
          Number(a.Anchor) -
          Number(b.Anchor)
        );

      });


      return {

        designIndex:
          designIndex,

        title:
          design.title ||
          (
            'Design ' +
            (designIndex + 1)
          ),

        base:
          design.base
            ? design.base.label
            : '',

        baseProductId:
          design.base &&
          design.base.productId
            ? String(
                design.base.productId
              )
            : '',

        capacity:
          capacity,

        charmCount:
          charms.length,

        assignmentCount:
          assignments.length,

        expectedCenter:
          expectedCenterAnchor,

        allChecksPass:
          allChecksPass,

        checks:
          checks,

        rows:
          rows,

        problems: {

          duplicateAnchors:
            duplicateAnchors,

          duplicateVariants:
            duplicateVariants,

          unassignedCharms:
            unassignedCharms,

          unknownAssignments:
            unknownAssignments,

          invalidAnchors:
            invalidAnchors,

          wrongMetalCharms:
            wrongMetalCharms

        }

      };

    });


  /* ======================================================
     OVERVIEW
  ====================================================== */

  console.group(
    '[Charm Bar Debug] Generated designs'
  );


  console.table(
    report.map(function (item) {

      return {

        Design:
          item.title,

        Base:
          item.base,

        BaseID:
          item.baseProductId,

        Capacity:
          item.capacity,

        Charms:
          item.charmCount,

        Anchors:
          item.assignmentCount,

        Center:
          item.expectedCenter,

        Status:
          item.allChecksPass
            ? 'PASS'
            : 'FAIL'

      };

    })
  );


  /* ======================================================
     EACH DESIGN
  ====================================================== */

  report.forEach(function (item) {

    console.group(
      '[Charm Bar Debug] ' +
      item.title
    );


    console.log(
      'Base:',
      item.base,
      '| Product ID:',
      item.baseProductId,
      '| Capacity:',
      item.capacity
    );


    console.table(
      item.rows
    );


    console.table([

      {
        Check:
          'Charm count <= capacity',
        Status:
          item.checks.capacity
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'One assignment per charm',
        Status:
          item.checks
            .assignmentCount
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'No duplicate anchors',
        Status:
          item.checks
            .duplicateAnchors
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'No duplicate variants',
        Status:
          item.checks
            .duplicateVariants
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'All charms assigned',
        Status:
          item.checks
            .allCharmsAssigned
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'No unknown assignments',
        Status:
          item.checks
            .noUnknownAssignments
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'Anchors within capacity',
        Status:
          item.checks
            .anchorsWithinCapacity
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'Correct charm metal',
        Status:
          item.checks
            .correctCharmMetal
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'Base matches metal/type',
        Status:
          item.checks
            .baseMatchesSelection
            ? 'PASS'
            : 'FAIL'
      },

      {
        Check:
          'Center rule',
        Status:
          item.checks.centerRule
            ? 'PASS'
            : 'FAIL'
      }

    ]);


    if (!item.allChecksPass) {

      console.warn(
        '[Charm Bar Debug] Problems:',
        item.problems
      );

    }


    console.groupEnd();

  });


  console.groupEnd();


  /*
    Also return everything, so you can do:

    var x = CB_DEBUG_DESIGNS();
    x[0]
  */

  return report;
};

function parsePriceValue(value) {
  if (
    value === null ||
    typeof value === 'undefined' ||
    value === ''
  ) {
    return 0;
  }

  var clean =
    String(value)
      .replace(/\s/g, '')
      .replace(',', '.');

  var match =
    clean.match(/\d+(?:\.\d+)?/);

  if (!match) {
    return 0;
  }

  var number =
    Number(match[0]);

  if (!Number.isFinite(number)) {
    return 0;
  }

  /*
    Shopify product.price is usually in cents:
    389 Kč = 38900
    89 Kč = 8900

    If the value is already visible text like "389 Kč",
    it stays 389.
  */
  if (number >= 3000) {
    return number / 100;
  }

  return number;
}

function getElementPrice(element) {
  if (!element) {
    return 0;
  }

  var candidates = [
    element.dataset.productPrice,
    element.dataset.price,
    element.dataset.variantPrice,
    element.getAttribute('data-product-price'),
    element.getAttribute('data-price'),
    element.getAttribute('data-variant-price')
  ];

  var priceElement =
    element.querySelector(
      '[data-product-price], [data-price], [data-variant-price], .price, [class*="price"]'
    );

  if (priceElement) {
    candidates.push(
      priceElement.dataset.productPrice,
      priceElement.dataset.price,
      priceElement.dataset.variantPrice,
      priceElement.getAttribute('data-product-price'),
      priceElement.getAttribute('data-price'),
      priceElement.getAttribute('data-variant-price'),
      priceElement.textContent
    );
  }

  for (var i = 0; i < candidates.length; i += 1) {
    var parsed =
      parsePriceValue(candidates[i]);

    if (parsed > 0) {
      return parsed;
    }
  }

  return 0;
}

function formatKcPrice(value) {
  var amount =
    Math.round(Number(value) || 0);

  return amount.toLocaleString('cs-CZ') + ' Kč';
}

function getDesignTotalPrice(design) {
  if (!design) {
    return 0;
  }

  var basePrice =
    design.base && design.base.price
      ? Number(design.base.price)
      : 0;

  var charmsPrice =
    (design.charms || []).reduce(function (sum, charm) {
      return sum + Number(charm.price || 0);
    }, 0);

  return basePrice + charmsPrice;
}

function generateDesigns(
  answers
) {

  var bases =
    getBasesForGeneratedDesigns(
      answers
    );


  var base1 =
    bases[0] || null;

  var base2 =
    bases[1] || null;

  var base3 =
    bases[2] || null;


  /* ======================================================
     PERSONAL REQUIRED CHARMS
  ====================================================== */

  var initial1 =
    findInitialCharm(
      answers.initial1,
      answers.metal
    );


  var initial2 =
    findInitialCharm(
      answers.initial2,
      answers.metal
    );


  var birthstone =
    findZodiacCharm(
      answers.zodiac,
      answers.metal
    );


  var requiredCharms =
    uniqueCharms([
      initial1,
      initial2,
      birthstone
    ]);


  /* ======================================================
     BUILD ONE SHARED RANDOM CONTEXT

     Important:
     all 3 designs use the same shuffled pools,
     while usedAcrossDesigns makes them pick
     different charms where possible.
  ====================================================== */

  var context =
    createRecommendationContext(
      answers
    );


  /* ======================================================
     COUNT USER-SPECIFIED CHARM INFORMATION

     Count things that represent an actual semantic
     charm request.

     Examples:

     Initial
     Birthstone
     Recipient
     Dog
     Music
     Travel
     etc.

     Metal / jewelry type / design style do NOT count.
  ====================================================== */

  var semanticInfoCount =
    context.requirements.length;


  if (
    answers.initial1
  ) {
    semanticInfoCount += 1;
  }


  if (
    answers.initial2
  ) {
    semanticInfoCount += 1;
  }


  if (
    answers.zodiac
  ) {
    semanticInfoCount += 1;
  }


  /* ======================================================
     PHYSICAL MAXIMUM FOR EACH BASE
  ====================================================== */

  var maxLimit1 =
    limitForDesign(
      answers,
      base1
    );


  var maxLimit2 =
    limitForDesign(
      answers,
      base2
    );


  var maxLimit3 =
    limitForDesign(
      answers,
      base3
    );


  /* ======================================================
     DESIGN DENSITY

     0–5 specified charm infos:
     Design 1 -> 5
     Design 2 -> 7
     Design 3 -> MAX

     6+ specified charm infos:
     Design 1 -> 7
     Design 2 -> MAX
     Design 3 -> MAX

     Math.min() ensures that we never exceed
     the physical capacity of the selected base.
  ====================================================== */

  var limit1;
  var limit2;
  var limit3;


  if (
    semanticInfoCount <= 5
  ) {

    limit1 =
      Math.min(
        5,
        maxLimit1
      );

    limit2 =
      Math.min(
        7,
        maxLimit2
      );

    limit3 =
      maxLimit3;

  } else {

    limit1 =
      Math.min(
        7,
        maxLimit1
      );

    limit2 =
      maxLimit2;

    limit3 =
      maxLimit3;

  }


  /*
    Keep this for testing for now.

    Example:
    semanticInfoCount: 3
    targets: [5, 7, 9]
  */

  console.log(
    '[Charm Bar] Design density',
    {
      semanticInfoCount:
        semanticInfoCount,

      capacities: [
        maxLimit1,
        maxLimit2,
        maxLimit3
      ],

      targets: [
        limit1,
        limit2,
        limit3
      ]
    }
  );


  /* ======================================================
     DESIGN 1
  ====================================================== */

  var design1Charms =
    buildQuizDesignCharms(
      requiredCharms,
      context,
      limit1
    );


  /* ======================================================
     DESIGN 2

     Same requirements,
     but fresh category candidates where available.
  ====================================================== */

  var design2Charms =
    buildQuizDesignCharms(
      requiredCharms,
      context,
      limit2
    );


  /* ======================================================
     DESIGN 3
  ====================================================== */

  var design3Charms =
    buildQuizDesignCharms(
      requiredCharms,
      context,
      limit3
    );


  return [

    {
      id:
        'safe',

      shortTitle:
        'Clean',

      title:
        'Clean Story',

      subtitle:
        'A different mix based on your selected interests.',

      base:
        base1,

      baseLabel:
        base1
          ? base1.label
          : 'Selected base',

      baseImage:
        base1
          ? base1.image
          : '',

      charms:
        design1Charms
    },


    {
      id:
        'personal',

      shortTitle:
        'Personal',

      title:
        'Personal Mix',

      subtitle:
        'Another interpretation of the same choices.',

      base:
        base2,

      baseLabel:
        base2
          ? base2.label
          : 'Selected base',

      baseImage:
        base2
          ? base2.image
          : '',

      charms:
        design2Charms
    },


    {
      id:
        'statement',

      shortTitle:
        'Statement',

      title:
        'Statement Look',

      subtitle:
        'A third mix using different matching charms where possible.',

      base:
        base3,

      baseLabel:
        base3
          ? base3.label
          : 'Selected base',

      baseImage:
        base3
          ? base3.image
          : '',

      charms:
        design3Charms
    }

  ];

}


  function createDesignPreviewFallback(design) {
    var preview =
      document.createElement('div');

    preview.className =
      'cb-design-preview';

    var baseImg =
      document.createElement('img');

    baseImg.className =
      'cb-design-preview-base';

    baseImg.src =
      makeLargeShopifyImageUrl(
        design.baseImage || getCurrentBaseImage(),
        1200
      );

    baseImg.alt =
      design.baseLabel || 'Design preview';

    preview.appendChild(baseImg);

    var positions =
      getAnchorPositions(design.charms.length);

    design.charms.forEach(function (charm, index) {
      var position =
        positions[index];

      if (!position) {
        return;
      }

      var img =
        document.createElement('img');

      img.className =
        'cb-design-preview-charm';

      img.src =
        makeLargeShopifyImageUrl(charm.image, 1000);

      img.alt =
        charm.nameClean || charm.name || 'Charm';

      img.style.left =
        position.left;

      img.style.top =
        position.top;

      preview.appendChild(img);
    });

    return preview;
  }

  function getCurrentBaseImage() {
    var image =
      document.querySelector('.charm_bar__base-product-image');

    return image && image.src
      ? makeLargeShopifyImageUrl(image.src, 1200)
      : '';
  }

  function getAnchorPositions(count) {
    var points =
      Array.from(
        document.querySelectorAll('#charm_bar__points-layer [data-point-index]')
      )
        .map(function (point) {
          return {
            index: Number(point.dataset.pointIndex || 0),
            left: point.style.left || '50%',
            top: point.style.top || '50%'
          };
        })
        .sort(function (a, b) {
          return a.index - b.index;
        });

    if (points.length) {
  var startIndex =
    Math.max(
      0,
      Math.floor((points.length - count) / 2)
    );

  return points.slice(startIndex, startIndex + count);
}

    var fallback = [
      { left: '50%', top: '72%' },
      { left: '65%', top: '64%' },
      { left: '35%', top: '64%' },
      { left: '72%', top: '48%' },
      { left: '28%', top: '48%' },
      { left: '78%', top: '32%' },
      { left: '22%', top: '32%' },
      { left: '81%', top: '15%' },
      { left: '19%', top: '15%' }
    ];

    return fallback.slice(0, count);
  }

  function applyDesignToBuilder(design) {
    if (!design) {
      return Promise.resolve();
    }

    if (state.isApplyingDesign) {
      return Promise.resolve();
    }

    state.isApplyingDesign = true;


clearResultApplyError();


if (resultView) {
  resultView.classList.add('cb-result-loading');
}

    return Promise.resolve()
      .then(function () {
        if (
          design.base &&
          design.base.element
        ) {
          design.base.element.click();
          return wait(450);
        }
      })
      .then(function () {
        return clearBuilderCharms();
      })
      .then(function () {

  return applyDesignCharmsToAnchors(
    design
  );

})
      .then(function () {
        return wait(250);
      })
      .catch(function (error) {

  console.warn(
    '[Charm Bar Quiz] Could not apply design:',
    error
  );


  showResultApplyError(
    'We could not load this design into the builder. Please try again.'
  );

})
      .then(function () {
        state.isApplyingDesign = false;

        if (resultView) {
          resultView.classList.remove('cb-result-loading');
        }
      });
  }

  function clearBuilderCharms() {
    var quantityGroups =
      Array.from(
        document.querySelectorAll('.charm-bar__quantity, .charm_bar__quantity')
      );

    var chain =
      Promise.resolve();

    quantityGroups.forEach(function (group) {
      chain = chain.then(function () {
        return clearQuantityGroup(group);
      });
    });

    return chain.then(function () {
      return wait(150);
    });
  }

  function clearQuantityGroup(group) {
    var valueEl =
      group.querySelector('.charm-bar__quantity-value, .charm_bar__quantity-value');

    var decreaseBtn =
      group.querySelector('.charm-bar__quantity-button--decrease, .charm_bar__quantity-button--decrease');

    if (!valueEl || !decreaseBtn) {
      return Promise.resolve();
    }

    var quantity =
      Number(valueEl.textContent || 0);

    var guard = 0;

    function step() {
      if (quantity <= 0 || guard >= 20) {
        return Promise.resolve();
      }

      decreaseBtn.click();
      guard += 1;

      return wait(45).then(function () {
        quantity =
          Number(valueEl.textContent || 0);

        return step();
      });
    }

    return step();
  }

  function addCharmToBuilder(charm) {
    if (!charm || !charm.variantId) {
      return Promise.resolve();
    }

    var selector =
      '.charm-bar__charm-item[data-product-variant-id="' + charm.variantId + '"],' +
      '.charm_bar__charm-item[data-product-variant-id="' + charm.variantId + '"]';

    var item =
      document.querySelector(selector);

    if (!item) {
      console.warn('[Charm Bar Quiz] Charm not found in builder:', charm);
      return Promise.resolve();
    }

    var increaseBtn =
      item.querySelector(
        '.charm-bar__quantity-button--increase, .charm_bar__quantity-button--increase'
      );

    if (!increaseBtn) {
      console.warn('[Charm Bar Quiz] Increase button missing:', charm);
      return Promise.resolve();
    }

    increaseBtn.click();

    return wait(95);
  }

  function triggerBuilderAddToCart() {
    var button =
      document.querySelector(
        '#charm_bar__add-to-cart-button, .charm_bar__toolbar-add-to-cart'
      );

    if (!button) {
      console.warn('[Charm Bar Quiz] Builder add-to-cart button not found.');
      return;
    }

    button.click();
  }

  function capitalize(value) {
    var text =
      String(value || '');

    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();